import store from './../store/index'

let langs = [
  {
    key: '用户名',
    value: 'Логин',
  },
  {
    key: '请输入新密码',
    value: 'Пожалуйста, введите новый пароль',
  },
  {
    key: '请输入完整邮箱',
    value: 'Пожалуйста, введите полный адрес электронной почты',
  },
  {
    key: '请先输入邮箱',
    value: 'Пожалуйста, сначала введите вашу электронную почту',
  },
  {
    key: '如果您想购买或者是需要拿样品，请与我们的工作人员联系',
    value:
      'Если Вы хотите напрямую совершить покупку или Вам необходимо приобрести образцы, пожалуйста, свяжитесь с нашими сотрудниками',
  },
  {
    key: '预计进口产品费用明细 ',
    value: 'Подробная информация о предполагаемых затратах на импорт',
  },
  {
    key: '*如果手机号码输入错误，将无法发送验证码',
    value:
      '*Если номер мобильного телефона введен неправильно, то код  подтверждения отправлен не будет',
  },
  {
    key: '*如果邮箱输入错误，将无法发送验证码',
    value:
      '*Если номер адрес электронной почты введен неправильно, то код подтверждения отправлен не будет',
  },
  {
    key: '请将您的个人信息填入下方',
    value: 'Пожалуйста, заполните Ваши персональные данные ниже',
  },
  {
    key: '银行转账',
    value: 'Банковский перевод',
  },
  {
    key: '将您订单中需花费的钱转账到我们账户',
    value: 'Перечислите сумму стоимости Вашего заказа на наш счет',
  },
  {
    key: '等待1至2个工作日处理订单.',
    value: 'Ожидание обработки заказа составляет от 1 до 2 рабочих дней.',
  },
  {
    key: '是否确认提交汇款?',
    value: 'Подтвердить ли отправку денежного перевода?',
  },
  {
    key: '物流说明',
    value: 'Информация о логистике',
  },
  {
    key:
      '使用以下银行数据通过您的在线银行或移动应用程序进行转账，订单处理后，将进行购买。',
    value:
      'Мы установили прочное партнерство с компанией Байкал Логистикс. Чтобы обеспечить плавные и безопасные финансовые операции, пожалуйста, свяжитесь с нами напрямую для получения конкретной информации о счете для перевода. Мы стремимся поддерживать эффективный процесс сотрудничества, обеспечивая точное и правильное движение каждого средства.',
  },
  {
    key: '请上传付款证明',
    value: 'Пожалуйста, загрузите квитанцию об оплате',
  },
  {
    key: '请填写备注信息',
    value: 'Пожалуйста, заполните поле для примечаний',
  },
  {
    key: '请输入付款金额',
    value: 'Пожалуйста, введите сумму платежа',
  },
  {
    key: '请填写转账金额',
    value: 'Пожалуйста, укажите сумму перевода',
  },
  {
    key: '请填写付款人姓名',
    value: 'Пожалуйста, укажите фамилию и имя плательщика',
  },
  {
    key: '手机号',
    value: 'Номер мобильного телефона',
  },
  {
    key: '手机号不能为空',
    value: 'Номер мобильного телефона нельзя оставить незаполненным',
  },
  {
    key: 'SSN(选填)',
    value: 'SSN (указывается по выбору)',
  },
  {
    key: '选填',
    value: 'Выбра заполн',
  },
  {
    key: '收件人银行信息',
    value: 'Банковская информация о получателе',
  },
  {
    key: '请选择日期',
    value: 'Пожалуйста, выберите дату',
  },
  {
    key: '使用订单号作为付款概念/参考',
    value: 'Используйте номер заказа в качестве ссылочного кода платежа',
  },
  {
    key: '它是如何运作的?',
    value: 'Как это работает?',
  },
  {
    key: '收款人名称',
    value: 'Имя получателя платежа',
  },
  {
    key: '提交人',
    value: 'Отправитель',
  },
  {
    key: '请输入提交人',
    value: 'Пожалуйста, введите отправителя',
  },
  {
    key: '请输入付款日期',
    value: 'Пожалуйста, введите дату платежа',
  },
  {
    key: '付款金额',
    value: 'Сумма платежа',
  },
  {
    key: '付款截图',
    value: 'Скрин-шот платежа',
  },
  {
    key: '确认转账',
    value: 'Подтвердите перевод',
  },
  {
    key: '单价',
    value: 'Цена',
  },
  {
    key: '预估俄罗斯国内运费',
    value: 'Предполагаемая стоимость расходов на перевозку по России',
  },
  {
    key: '包含运费产品总成本',
    value: 'Общая стоимость товара, включая расходы на перевозку',
  },
  {
    key: '密码',
    value: 'Пароль',
  },
  {
    key: '当前商品',
    value: 'Текущие товары',
  },
  {
    key: '忘记密码?',
    value: 'Забыли пароль?',
  },
  {
    key: '写邮件与我们沟通',
    value: 'Напишите письмо на электронную почту, чтобы связаться с нами',
  },
  {
    key: '请输入关键词或通过商品图片搜索',
    value:
      'Пожалуйста, введите ключевые слова или выполните поиск по изображениям товаров',
  },
  {
    key: '添加收藏成功',
    value: 'Успешно добавлено в избранное',
  },
  {
    key: '银行卡支付',
    value: 'Платеж банковской картой',
  },
  {
    key: '取消收藏成功',
    value: 'Отменить сохранение в избранное',
  },
  {
    key: '请填写收件人',
    value: 'Пожалуйста, укажите получателя товара',
  },
  {
    key: '请勿传入空值',
    value: 'Поле не может быть незаполненным',
  },
  {
    key: '请输入城市',
    value: 'Пожалуйста, введите город',
  },
  {
    key: '请输入收货地址',
    value: 'Пожалуйста, введите адрес получения товара',
  },
  {
    key: '不能为空',
    value: 'Поле не может быть незаполненным',
  },
  {
    key: '新增地址',
    value: 'Новый адрес',
  },
  {
    key: '产品数量',
    value: 'Количество товара',
  },
  {
    key: '邮箱验证码',
    value: 'Код подтверждения электронной почты',
  },
  {
    key: '请输入邮箱验证码',
    value: 'Пожалуйста, введите код подтверждения электронной почты',
  },
  {
    key: '产品详情',
    value: 'Подробная информация о товаре',
  },
  {
    key: '替换产品',
    value: 'Заменить товар',
  },
  {
    key: '咨询',
    value: 'Проконсультироваться',
  },
  {
    key: '谷歌登录',
    value: 'Авторизироваться через Google',
  },
  {
    key: '用户',
    value: 'Пользователь',
  },
  {
    key: '手机',
    value: 'Телефон',
  },
  {
    key: '耳机',
    value: 'Наушники',
  },
  {
    key: '电脑',
    value: 'Компьютер',
  },
  {
    key: '谢谢，你的订单号',
    value: 'Спасибо. Ваш номер заказа',
  },
  {
    key:
      '已生成正确，并且已经在发送到我们仓库的过程中。 我们已经向您发送了一封包含详细信息的电子邮件。请按照个人中心中的状态进行操作',
    value:
      'сгенерирован правильно и уже находится в процессе отправки в наш операционный центр обработки данных. Мы отправили Вам электронное письмо с подробной информацией. Пожалуйста, выполняйте дальнейшие действия в зависимости от статуса, отображаемого в личном кабинете.',
  },
  {
    key: '最低入金金额',
    value: 'Минимальная сумма денежного перевода',
  },
  {
    key: '订单应付款金额',
    value: 'Сумма за заказ, подлежащая оплате ',
  },
  {
    key: '加入商品库',
    value: 'Добавить в лист товаров',
  },
  {
    key: '记住密码',
    value: 'Запомнить пароль',
  },
  {
    key: '请输入账号',
    value: 'Пожалуйста, введите логин ',
  },
  {
    key: '请输入密码',
    value: 'Пожалуйста, введите пароль',
  },
  {
    key: '请选择认证方式',
    value: 'Пожалуйста, выберите способ верификации',
  },
  {
    key: '请输入你的账户名称',
    value: 'Пожалуйста, введите логин от Вашего аккаунта',
  },
  {
    key: '手机号码',
    value: 'Номер мобильного телефона',
  },
  {
    key: '验证码获取',
    value: 'Получить код верификации',
  },
  {
    key: '城市名',
    value: 'Название города',
  },
  {
    key: '帐号注册完成',
    value: 'Регистрация аккаунта завершена',
  },
  {
    key: '非常感谢您的注册',
    value: 'Благодарим Вас за регистрацию!',
  },
  {
    key: '国家名',
    value: 'Название страны',
  },
  {
    key: '填写个人信息',
    value: 'Заполните персональные данные',
  },
  {
    key: '个人信息确认',
    value: 'Подтвердите персональные данные',
  },
  {
    key: '完成注册',
    value: 'Завершение регистрации',
  },
  {
    key: '账户注册（需要信息）',
    value: 'Регистрация аккаунта (требуется предоставление данных) ',
  },
  {
    key: '姓氏',
    value: 'Фамилия',
  },
  {
    key: '请输入姓氏',
    value: 'Пожалуйста, введите фамилию',
  },
  {
    key: '名字',
    value: 'Имя',
  },
  {
    key: '请输入名字',
    value: 'Пожалуйста, введите имя',
  },
  {
    key: '密码输入不一致',
    value: 'Введенный пароль не соответствует указанному ранее',
  },
  {
    key: '请输入正确的邮箱地址',
    value: 'Пожалуйста, введите корректный адрес электронной почты',
  },
  {
    key: '电话',
    value: 'Телефон',
  },
  {
    key: '请输入您的手机号',
    value: 'Пожалуйста, введите номер Вашего мобильного телефона',
  },
  {
    key: '请输入NIF',
    value: 'Введите ИНН',
  },
  {
    key: '发送验证码',
    value: 'Отправить код подтверждения',
  },
  {
    key: '密码请控制在6位以上16位以内',
    value: 'Допустимая длина пароля 6-16 символов',
  },
  {
    key: '注册完成',
    value: 'Регистрация завершена',
  },
  {
    key: '账号注册完成，非常感谢您的注册',
    value: 'Регистрация аккаунта завершена, благодарим Вас за регистрацию!',
  },
  {
    key: '去登录',
    value: 'Войти',
  },
  {
    key: '关键词',
    value: 'Категория',
  },
  {
    key: '信息完善',
    value: 'Завершить заполнение информации',
  },
  {
    key: '取消的订单',
    value: 'Заказ отменён',
  },
  {
    key: '请您填写以下信息，以便完成注册',
    value:
      'Пожалуйста, для завершения регистрации заполните следующую информацию',
  },
  {
    key: '搜索结果有问题？',
    value: 'Имеется проблема с результатами поиска?',
  },
  {
    key: '没有找到商品，请换一张图片试试',
    value:
      'Товар не найден, пожалуйста, попробуйте найти товар по другому изображению',
  },
  {
    key: '请输入正确的手机号码',
    value: 'Пожалуйста, введите корректный номер мобильного телефона',
  },
  {
    key: '注册信息',
    value: 'Регистрационная информация',
  },
  {
    key: '登录失效',
    value: 'Ошибка авторизации',
  },
  {
    key: '个人中心',
    value: 'Личный кабинет',
  },
  {
    key: '意见反馈',
    value: 'Обратная связь',
  },
  {
    key: '退出登录',
    value: 'Выйти из аккаунта',
  },
  {
    key: '登录',
    value: 'Войти',
  },
  {
    key: '注册',
    value: 'Регистрация',
  },
  {
    key: '购物车',
    value: 'Корзина',
  },
  {
    key: '提现金额必须大于0',
    value: 'Сумма вывода денежных средств должна быть больше 0',
  },
  {
    key: '感谢您的下单，您的订单已经成功提出。',
    value: 'Благодарим Вас за заказ. Ваш заказ успешно передан в работу.',
  },
  {
    key: '正在进行的报价',
    value: 'Текущая установленная цена',
  },
  {
    key: '为您推荐',
    value: 'Рекомедуемое Вам',
  },
  {
    key: '新手导航',
    value: 'Навигатор для новичков',
  },
  {
    key: '关于Sponlax',
    value: 'О нас',
  },
  {
    key: '佣金比例',
    value: 'Комиссионный сбор за обслуживание',
  },
  {
    key: '国际运费说明',
    value: 'Информация о международной перевозке',
  },
  {
    key: '已驳回',
    value: 'Заявка на вывод денежных средств была отклонена',
  },
  {
    key: '查看相似',
    value: 'Смотреть похожие товары',
  },
  {
    key: '所有类别',
    value: 'Каталог',
  },
  {
    key: '查看更多推荐',
    value: 'Смотреть больше рекомендаций',
  },
  {
    key: '已售',
    value: 'Продано',
  },
  {
    key: '关于费用',
    value: 'Об оплате',
  },
  {
    key: '首页',
    value: 'Стартовая страница',
  },
  {
    key: '请输入新手机号',
    value: 'Пожалуйста, введите новый номер мобильного телефона',
  },
  {
    key: '新手机号码',
    value: 'Новый номер мобильного телефона',
  },
  {
    key: '加入购物车',
    value: 'Добавить в корзину покупок',
  },
  {
    key: '总计',
    value: 'Итого',
  },
  {
    key: '邮编输入错误',
    value: 'Почтовый индекс введен неверно',
  },
  {
    key: '在库数',
    value: 'Складские остатки',
  },
  {
    key: '购物车添加成功',
    value: 'Успешно добавлено в корзину покупок',
  },
  {
    key: '移除收藏夹成功',
    value: 'Успешно удалено из избранного',
  },
  {
    key: '收藏店铺成功',
    value: 'Магазин успешно сохранен в избранное',
  },
  {
    key: '商家推荐',
    value: 'Рекомендуемое продавцом',
  },
  {
    key: '收藏店铺',
    value: 'Сохранить магазин в избранное',
  },
  {
    key: '保持登录状态',
    value: 'Оставайся авторизированным',
  },
  {
    key: '电子邮箱',
    value: 'Адрес эллектронной почты',
  },
  {
    key: '请输入邮箱/手机号',
    value: 'Пожалуйста, введите адрес электронной почты/мобильный телефон',
  },
  {
    key: '新会员注册',
    value: 'Регистрация нового члена',
  },
  {
    key: '账户名或者密码输入错误',
    value: 'Логин или пароль введены неверно',
  },
  {
    key: '国家',
    value: 'Страна',
  },
  {
    key: '登录名',
    value: 'Логин для авторизации',
  },
  {
    key: '密码确认',
    value: 'Подтверждение пароля',
  },
  {
    key: '验证码',
    value: 'Код подтверждения',
  },
  {
    key: '运输到仓库',
    value: 'Привезен на склад',
  },
  {
    key: 'SSN输入错误',
    value: 'Неправильный SSN',
  },
  {
    key: 'NIF / DNI',
    value: 'NIF/DNI',
  },
  {
    key: '请输入新的密码',
    value: 'Пожалуйста, введите новый пароль',
  },
  {
    key: '请再次输入密码',
    value: 'Пожалуйста, введите пароль еще раз',
  },
  {
    key: '入库完了',
    value: 'Регистрация товара на складе окончена',
  },
  {
    key: '请输入SSN',
    value: 'Пожалуйста, введите SSN',
  },
  {
    key: '资金变动明细',
    value: 'Подробная информация об изменениях денежных средств',
  },
  {
    key: 'Sponlax',
    value: 'Sponlax',
  },
  {
    key: 'Sponlax从事于批发进口，不提供任何零售服务',
    value:
      'Sponlax занимается оптовым импортом и не предоставляет никаких услуг по розничной торговле',
  },
  {
    key: '联系工作人员',
    value: 'Связаться с сотрудниками',
  },
  {
    key: 'Sponlax的用户协议和隐私政策',
    value: 'Пользовательское соглашение и политика конфиденциальности Sponlax',
  },
  {
    key: '的用户协议',
    value: 'Пользовательское соглашение',
  },
  {
    key: '的用户协议和隐私政策',
    value: 'Пользовательское соглашение и политика конфиденциальности',
  },
  {
    key: '待入金',
    value: 'Ожидается оплата',
  },
  {
    key: '提现中',
    value: 'В процессе вывода ',
  },
  {
    key: '上架完了',
    value: 'В наличии',
  },
  {
    key: 'and',
    value: ' и',
  },
  {
    key: '新电子邮箱',
    value: 'Новый адрес электронной почты',
  },
  {
    key: '商品标题',
    value: 'Тема товаров',
  },
  {
    key: '同意以上协议，进入下一步',
    value:
      'Выражаю согласие с вышеуказанным соглашением и перехожу к следующему шагу',
  },
  {
    key: '如何注册/登录？',
    value: 'Как зарегистрироваться/авторизироваться?',
  },
  {
    key: '请输入新的电子邮箱',
    value: 'Пожалуйста, введите новый адрес электронной почты',
  },
  {
    key: '已被使用',
    value: 'Уже используется',
  },
  {
    key: '验证码错误',
    value: 'Проверочный код неверен',
  },
  {
    key: '没有找到商品，请换一个关键词试试',
    value:
      'Товар не найден, пожалуйста, используйте другое ключевое слово и попробуйте снова',
  },
  {
    key: '商品关键词或阿里巴巴、淘宝商品URL',
    value:
      'Ключевые слова в названии товара или ссылка на товар на сайте Alibaba, Taobao',
  },
  {
    key: '商品替换',
    value: 'Замена товара',
  },
  {
    key: '常见问题',
    value: 'Часто задаваемые вопросы ',
  },
  {
    key:
      '我们根据订单总额收取佣金。对于每个金额，都有特定百分比的佣金。请参阅下表，了解您的订单将对应多少百分比。',
    value:
      'Мы взимаем комиссию за обработку заказа в зависимости от общей оплачиваемой суммы заказа. Разные суммы соответствуют комиссионным ставкам разного уровня. Пожалуйста, ознакомьтесь с таблицей ниже, чтобы узнать комиссионную ставку, соответствующую сумме Вашего заказа.',
  },
  {
    key: '采购商品金额（卢布）',
    value: 'Сумма за приобретенный товар (в рублях)',
  },
  {
    key: 'option说明界面',
    value: 'Интерфейс с описанием дополнительных услуг',
  },
  {
    key: '件',
    value: 'Шт',
  },
  {
    key: '会员服务',
    value: 'Услуги для членов',
  },
  {
    key: '会员等级',
    value: 'Уровень членства',
  },
  {
    key: '附加服务说明',
    value: 'Описание дополнительных услуг',
  },
  {
    key: '店铺信息',
    value: 'Информация о магазине',
  },
  {
    key: '收藏商品',
    value: 'Избранные товары',
  },
  {
    key: '进入店铺',
    value: 'Войти в магазин',
  },
  {
    key: '移出收藏夹',
    value: 'Удалить из избранного',
  },
  {
    key: '商品详情',
    value: 'Подробная информация о товаре',
  },
  {
    key: '商品推荐',
    value: 'Рекомендуемые товары',
  },
  {
    key: '单价',
    value: 'Цена за единицу',
  },
  {
    key: '60',
    value: '',
  },
  {
    key: '价格',
    value: 'Цена',
  },
  {
    key: '修改州',
    value: 'Изменить адрес',
  },
  {
    key: '数量',
    value: 'Количество',
  },
  {
    key: '运费',
    value: 'Расходы на перевозку',
  },
  {
    key: '暂无此规格',
    value: 'На данный момент спецификация отсутствует',
  },
  {
    key: '60秒内已发送过一次验证码',
    value: 'Код подтверждения был отправлен один раз в течение 60 секнд',
  },
  {
    key: '发送短信失败',
    value: 'Не удалось отправить SMS-сообщение',
  },
  {
    key: '结算',
    value: 'Расчёт',
  },
  {
    key: '确认删除该商品吗？',
    value: 'Подтвердить удаление данного товара?',
  },
  {
    key: '确认',
    value: 'Подтвердить',
  },
  {
    key: '订单金额',
    value: 'Сумма заказа',
  },
  {
    key: '缺少必填项',
    value: 'Отсутствуют обязательные для заполнения поля',
  },
  {
    key: '您目前没有优惠券',
    value: 'На данный момент у Вас нет скидочных купонов',
  },
  {
    key: '请选择优惠券',
    value: 'Пожалуйста, выберите скидочный купон',
  },
  {
    key: '是否将选中的商品移除购物车?',
    value: 'Удалить выбранный товар из корзины покупок?',
  },
  {
    key: '未选择操作的商品',
    value: 'Для выполнения действия товары не выбраны',
  },
  {
    key: '删除成功',
    value: 'Успешно удалено',
  },
  {
    key: '购物车商品删除成功',
    value: 'Товары успешно удалены из корзины покупок',
  },
  {
    key: '保存成功',
    value: 'Успешно сохранено',
  },
  {
    key: '运输中配送单',
    value: 'Сопроводительный документ на товары, находящихся в пути',
  },
  {
    key: '去购物',
    value: 'Направиться совершать покупки',
  },
  {
    key: '人气商品',
    value: 'Популярные товары',
  },
  {
    key: '更改头像',
    value: 'Изменить фото профиля',
  },
  {
    key: '头像上传中',
    value: 'Фото профиля загружается',
  },
  {
    key: '张',
    value: 'Шт',
  },
  {
    key: '重新加载',
    value: 'Загрузить снова',
  },
  {
    key: '佣金',
    // value: 'Комиссия',
    value: 'Комиссионные',
  },
  {
    key: '重量',
    value: 'Вес',
  },
  {
    key: '未提出订单',
    value: 'Заказ не подан',
  },
  {
    key: '提出时间',
    value: 'Время подачи',
  },
  {
    key: '待发货配送单',
    value: 'Сопроводительный документ  на товары, ожидающие отправки',
  },
  {
    key: '运输中',
    value: 'В пути',
  },
  {
    key: '运费报价中',
    value: 'Стоимость перевозки в процессе установки',
  },
  {
    key: '运费待付款',
    value: 'Ожидается оплата стоимости перевозки',
  },
  {
    key: '国际派送中',
    value: 'Международная перевозка в процессе доставки',
  },
  {
    key: '我的券包',
    value: 'Мой пакет купонов',
  },
  {
    key: '使用记录',
    value: 'История использования',
  },
  {
    key: '请选择',
    value: 'Пожалуйста, выберите',
  },
  {
    key: '请输入内容',
    value: 'Пожалуйста, введите текст',
  },
  {
    key: '优惠券/代金券编码',
    value: 'Код скидочного купона/платежного купона',
  },
  {
    key: '类别',
    value: 'Категория',
  },
  {
    key: '额度/可使用次数',
    value: 'Сумма/ количество возможных использований',
  },
  {
    key: '生效时间段',
    value: 'Период действия',
  },
  {
    key: '使用日期',
    value: 'Дата использования',
  },
  {
    key: '使用状态',
    value: 'Статус использования',
  },
  {
    key: '订单内容',
    value: 'Содержание заказа',
  },
  {
    key: '订单号',
    value: '№ заказа',
  },
  {
    key: '主页',
    value: 'Стартовая страница',
  },
  {
    key: '操作',
    value: 'Операции',
  },
  {
    key: '订单管理',
    value: 'Заказ',
  },
  {
    key: '单个订单不能超过60番产品，请调整提出番数',
    value:
      'Один заказ не может содержать более 60-ти товаров, пожалуйста, измените количество товаров, передаваемых в обработку',
  },
  {
    key: '问题产品',
    value: 'Бракованные товары',
  },
  {
    key: '中国国内物流状态',
    value: 'Статус логистики внутри Китая',
  },
  {
    key: '仓库',
    value: 'Склад',
  },
  {
    key: '发货委托',
    value: 'Доверенность на отправку товара',
  },
  {
    key: '国际物流状态',
    value: 'Статус международной логистики',
  },
  {
    key: '售后',
    value: 'Послепродажное обслуживание',
  },
  {
    key: '账户余额管理',
    value: 'Управление балансом аккаунта',
  },
  {
    key: '请先登录账号',
    value: 'Пожалуйста, сначала войдите в аккаунт',
  },
  {
    key: '支付账单',
    value: 'Заплатить по счету',
  },
  {
    key: '暂时没有可使用的优惠券',
    value: 'На данный момент нет доступных скидочных купонов',
  },
  {
    key: '收藏',
    value: 'Избранное',
  },
  {
    key: '产品',
    value: 'Товары',
  },
  {
    key: '商品库列表',
    value: 'Список в листе товаров',
  },
  {
    key: '个人信息管理',
    value: 'Управление персональными данными',
  },
  {
    key: '修改个人信息',
    value: 'Изменить личные данные',
  },
  {
    key: '我的收货地址',
    value: 'Мой адрес получения товаров',
  },
  {
    key: '员工账户',
    value: 'Аккаунт сотрудника',
  },
  {
    key: '更改密码',
    value: 'Изменить пароль',
  },
  {
    key: '预购订单',
    value: 'Предварительный заказ',
  },
  {
    key: '全部订单',
    value: 'Все заказы',
  },
  {
    key: '报价中',
    value: 'В процессе установки цены',
  },
  {
    key: '等待付款',
    value: 'В ожидании оплаты',
  },
  {
    key: '正在购买',
    value: 'В процессе покупки',
  },
  {
    key: '购买完成',
    value: 'Покупка завершена',
  },
  {
    key: '已取消',
    value: 'Отменено',
  },
  {
    key: '已取消(订单状态)',
    value: 'Отменен (статус заказа)',
  },
  {
    key: '请输入关键词搜索',
    value: 'Пожалуйста, введите ключевые слова для поиска',
  },
  {
    key: '开始日期',
    value: 'Дата начала',
  },
  {
    key: '至',
    value: 'до',
  },
  {
    key: '结束日期',
    value: 'Дата окончания',
  },
  {
    key: '搜索',
    value: 'Поиск',
  },
  {
    key: '导出excel',
    value: 'Экспорт в Excel',
  },
  {
    key: '检品中',
    value: 'В процессе проверки товаров',
  },
  {
    key: '检品中订单',
    value: 'Заказы, находящиеся в процессе проверки товаров',
  },
  {
    key: '上架完了订单',
    value: 'Заказы, размещенные на продажу',
  },
  {
    key: '在Sponlax仓库中',
    value: 'На складе Sponlax',
  },
  {
    key: '订单状态',
    value: 'Статус заказа',
  },
  {
    key: '前往xx页',
    value: 'Перейти на страницу xx',
  },
  {
    key: '提出日期',
    value: 'Время оплаты',
  },
  {
    key: '付款日期',
    value: 'Дата платежа',
  },
  {
    key: '购买完成日期',
    value: 'Время завершения покупки',
  },
  {
    key: '等待处理',
    value: 'Ожидает обработку',
  },
  {
    key: '处理中',
    value: 'В обработке',
  },
  {
    key: '所有问题产品详情',
    value: 'Подробная информация по всем проблемным товарам',
  },
  {
    key: '联系负责人',
    value: 'Связаться с отвественным лицом',
  },
  {
    key: '确认签收',
    value: 'Подтверждить получение',
  },
  {
    key: '问题提出日期',
    value: 'Дата передачи вопроса на рассмотрение',
  },
  {
    key: '有问题的商品数',
    value: 'Количество проблемных товаров',
  },
  {
    key: '问题商品数量',
    value: 'Количество проблемных товаров',
  },
  {
    key: '暂无数据',
    value: 'В настоящий момент данные отсутствуют',
  },
  {
    key: '数据获取错误',
    value: 'Ошибка при получении данных!',
  },
  {
    key: '立即支付',
    value: 'Немедленная оплата',
  },
  {
    key: '问题照片',
    value: 'Фотографии проблемного товара',
  },
  {
    key: '问题说明',
    value: 'Описание проблемного товара',
  },
  {
    key: '处理意见',
    value: 'Обработка жалоб и предложений',
  },
  {
    key: '查看照片',
    value: 'Смотреть фотографии',
  },
  {
    key: '统一回复',
    value: 'Единый ответ',
  },
  {
    key: '单价（元）',
    value: 'Цена за единицу (в юанях)',
  },
  {
    key: '请输入处理意见',
    value: 'Введите жалобы и предложения для обработки',
  },
  {
    key: '全部',
    value: 'Все',
  },
  {
    key: '待发货',
    value: 'Ожидается отправка товаров',
  },
  {
    key: '等待发货',
    value: 'Ожидается отправка товаров',
  },
  {
    key: '照片',
    value: 'Фотографии',
  },
  {
    key: '属性',
    value: 'Атрибуты',
  },
  {
    key: '未选择服务',
    value: 'Нет выбранных услуг',
  },
  {
    key: '选择该商品',
    value: 'Выбрать данный товар',
  },
  {
    key: '单价(出入金)',
    value: 'Цена за единицу (входящие и выходящие денежные средства)',
  },
  {
    key: '中国运费',
    value: 'Расходы на перевозку по Китаю',
  },
  {
    key: '国内运费',
    value: 'Расходы на перевозку внутри страны',
  },
  {
    key: '备注栏',
    value: 'Столбец для примечаний',
  },
  {
    key: '状态',
    value: 'Статус',
  },
  {
    key: '国内派送中',
    value: 'Доставка внутри страны',
  },
  {
    key: '没有备注',
    value: 'Примечания отсутствуют',
  },
  {
    key: '此订单无备注',
    value: 'Примечания к данному заказу отсутствуют',
  },
  {
    key: '回到首页',
    value: 'Вернуться на стартовую страницу',
  },
  {
    key: '可提出',
    value: 'Готов к передаче',
  },
  {
    key: '装箱中',
    value: 'Packing',
  },
  {
    key: '提出配送单',
    value: 'В процессе затаривания в контейнер',
  },
  {
    key: '产品费用',
    value: 'Плата за товар',
  },
  {
    key: '购买数量',
    value: 'Количество приобретаемого товара',
  },
  {
    key: '可发货数量',
    value: 'Количество товара, которое может быть отправлено',
  },
  {
    key: '全部配送单',
    value: 'Все сопроводительные документы',
  },
  {
    key: '等待付款(订单列表)',
    value: 'В ожидании оплаты (список заказов)',
  },
  {
    key: '重量（Kg）',
    value: 'Вес (кг)',
  },
  {
    key: '国际物流费用',
    value: 'Стоимость международных логистических услуг',
  },
  {
    key: '西班牙国内配送中',
    value: 'В пути на территории России',
  },
  {
    key: '国际运输中',
    value: 'Международная доставка',
  },
  {
    key: '已清关',
    value: 'Уже растоможен',
  },
  {
    key: '已签收',
    value: 'Доставлено',
  },
  {
    key: '俄罗斯派送中',
    value: 'В процессе доставки по России',
  },
  {
    key: '配送单号',
    value: 'Номер упаковочного листа',
  },
  {
    key: '发货时间',
    value: 'Время отправки товара',
  },
  {
    key: '通关方式',
    value: 'Способ прохождения через таможню',
  },
  {
    key: '国际运输方式',
    value: 'Способ международной перевозки',
  },
  {
    key: '箱数',
    value: 'Количеств контейнеров',
  },
  {
    key: '去提现',
    value: 'Направиться для вывода',
  },
  {
    key: '剩余可用点数',
    value: 'Оставшиеся доступные баллы',
  },
  {
    key: '已充值待确认点数',
    value: 'Уже пополненные баллы, которые ожидают подтверждения',
  },
  {
    key: '提现中',
    value: 'В процессе вывода',
  },
  {
    key: '充值',
    value: 'Пополнение',
  },
  {
    key: '公司名称',
    value: 'Название компании',
  },
  {
    key: '公司地址',
    value: 'Адрес компании',
  },
  {
    key: '公司营业执照',
    value: 'Лицензия на ведение коммерческой деятельности',
  },
  {
    key: '银行账户',
    value: 'Банковский счет',
  },
  {
    key: 'SWIFT账户',
    value: 'Счет SWIFT',
  },
  {
    key: '汇款日期',
    value: 'Дата перевода',
  },
  {
    key: '汇款日期不能为空',
    value: 'Дата перевода не может быть незаполнена',
  },
  {
    key: '选择日期',
    value: 'Выберите дату',
  },
  {
    key: '汇款人',
    value: 'Отправитель перевода',
  },
  {
    key: '汇款人不能为空',
    value: 'Отправитель перевода не может быть неуказан',
  },
  {
    key: '汇款金额',
    value: 'Сумма перевода',
  },
  {
    key: '汇款截图',
    value: 'Скрин-шот перевода',
  },
  {
    key: '附加服务数量不能为0',
    value: 'Количество дополнительных услуг не может быть равно 0',
  },
  {
    key: '支付',
    value: 'Оплатить',
  },
  {
    key: '提现申请信息',
    value: 'Информация о заявке на вывод средств',
  },
  {
    key: '请输入订单号或配送单号搜索',
    value:
      'Пожалуйста, введите номер заказа или номер сопроводительного документа для поиска',
  },
  {
    key: '当前账户余额',
    value: 'Текущий баланс счета',
  },
  {
    key: '基本信息',
    value: 'Основная информация',
  },
  {
    key: '选择汇款方式',
    value: 'Пожалуйста, выберите способ осуществления перевода',
  },
  {
    key: '请输入用户名',
    value: 'Пожалуйста, введите имя пользователя',
  },
  {
    key: '账户名称',
    value: 'Логин',
  },
  {
    key: '请输入账户名称',
    value: 'Пожалуйста, введите логин',
  },
  {
    key: '提现金额',
    value: 'Сумма вывода',
  },
  {
    key: '提现申请原因',
    value: 'Причина подачи заявления на вывод',
  },
  {
    key: '确认提交',
    value: 'Подтвердить передачу',
  },
  {
    key: '信息确认',
    value: 'Подтверждение информации',
  },
  {
    key: '请输入银行账户',
    value: 'Пожалуйста, введите банковский счет',
  },
  {
    key: '请输入提现金额',
    value: 'Пожалуйста, введите сумму для вывода',
  },
  {
    key: '请输入提现申请原因',
    value: 'Пожалуйста, введите причину подачи заявления на вывод',
  },
  {
    key: '请您核对以下信息是否正确',
    value: 'Пожалуйста, проверьте, верна ли следующая информация',
  },
  {
    key: '汇款取款历史',
    value: 'История денежных переводов/вывода денежных средств',
  },
  {
    key: '日期（财务确认日期）',
    value: 'Дата (Дата финансового подтверждения)',
  },
  {
    key: '交易类型',
    value: 'Вид транзакции',
  },
  {
    key: '支付方式',
    value: 'Способ платежа',
  },
  {
    key: '发票号',
    value: 'Номер инвойса',
  },
  {
    key: '总金额',
    value: 'Общая сумма',
  },
  {
    key: '明细',
    value: 'Детализация',
  },
  {
    key: '收支',
    value: 'Платёжный баланс',
  },
  {
    key: '账户余额',
    value: 'Баланс счета',
  },
  {
    key: '配送单',
    value: 'Сопроводительный документ',
  },
  {
    key: '提现记录',
    value: 'История вывода',
  },
  {
    key: '此配送单已正式提出，请勿重复操作',
    value:
      'Этот сопроводительный документ был официально предъявлен, пожалуйста, не повторяйте операцию',
  },
  {
    key: '发起时间',
    value: 'Дата начала',
  },
  {
    key: '流水号',
    value: 'Серийный номер',
  },
  {
    key: '收款户名',
    value: 'Имя получателя платежа',
  },
  {
    key: '收款户号',
    value: 'Номер расчетного счета получателя платежа',
  },
  {
    key: '处理状态',
    value: 'Статус обработки',
  },
  {
    key: '待审核',
    value: 'В ожидании рассмотрения',
  },
  {
    key: '查看凭证',
    value: 'Смотреть подтверждающий документ',
  },
  {
    key: '人工调整',
    value: 'Корректировка вручную',
  },
  {
    key: '下载',
    value: 'Скачать',
  },
  {
    key: '已被停用',
    value: 'Использование прекращено',
  },
  {
    key: '是否删除选中的商品',
    value: 'Следует ли удалить выбранный товар',
  },
  {
    key: '是否删除选中的配送单？',
    value: 'Следует ли удалить выбранный сопроводительный документ?',
  },
  {
    key: '请至少选择一项',
    value: 'Пожалуйста, выберите хотя бы один пункт',
  },
  {
    key: '商品链接',
    value: 'Ссылка на товар',
  },
  {
    key: '商品状态',
    value: 'Статус',
  },
  {
    key: '入库中',
    value: 'Поступил на склад',
  },
  {
    key: '商品金额变动明细',
    value: 'Подробная информация об изменениях суммы оплаты за товар',
  },
  {
    key: '序号',
    value: 'Номер',
  },
  {
    key: '调整前数据',
    value: 'Данные до корректировки',
  },
  {
    key: '调整后数据',
    value: 'Данные после корректировки',
  },
  {
    key: '出入金编号',
    value: 'Номер, присвоенный при изменении суммы денежных средств',
  },
  {
    key: '出入金类别',
    value: 'Категория изменения  денежных средств',
  },
  {
    key: '调整时间',
    value: 'Время корректиовки',
  },
  {
    key: '调整具体明细',
    value: 'Подробная детализация корректировки',
  },
  {
    key: '入金额',
    value: 'Сумма средств вносимых безналичным переводом',
  },
  {
    key: '出金额',
    value: 'Сумма оплаченных денежных средств',
  },
  {
    key: '正常',
    value: 'Стандартно',
  },
  {
    key: '请输入备注',
    value: 'Пожалуйста, введите примечание',
  },
  {
    key: '店铺名称',
    value: 'Название магазина',
  },
  {
    key: '选中移出',
    value: 'Удалить из выбранных',
  },
  {
    key: '是否删除此店铺',
    value: 'Следует ли удалить данный магазин',
  },
  {
    key: '提示',
    value: 'Напоминание',
  },
  {
    key: '缺少必填选项',
    value: 'Отсутствуют обязательные для заполнения поля',
  },
  {
    key: '请至少选择一个商品',
    value: 'Пожалуйста, выберите хотя бы один товар',
  },
  {
    key: '商品库提出订单',
    value: 'Оформить заказ в листе товаров',
  },
  {
    key: '商品编号',
    value: 'Номер товара',
  },
  {
    key: '商品备注详情',
    value: 'Подробная информация о примечаниях к товару',
  },
  {
    key: '请输入备注信息',
    value: 'Пожалуйста, введите примечание',
  },
  {
    key: '添加',
    value: 'Добавить',
  },
  {
    key: '商品库添加商品',
    value: 'Добавить товар в лист товаров',
  },
  {
    key: '商品图片',
    value: 'Картинка',
  },
  {
    key: '商品属性',
    value: 'Характер',
  },
  {
    key: '添加一行',
    value: 'Добавить строку',
  },
  {
    key: '请输入商品链接',
    value: 'Пожалуйста, введите ссылку на товар',
  },
  {
    key: '保存中',
    value: 'В процессе сохранения',
  },
  {
    key: '修改地址',
    value: 'Изменить адрес',
  },
  {
    key: '默认地址',
    value: 'Адрес по умолчанию',
  },
  {
    key: '同步到进口商',
    value: 'Синхронизация с импортером',
  },
  {
    key: '编辑',
    value: 'Редактировать',
  },
  {
    key: '这是你的控制面板',
    value: 'Это Ваша панель управления',
  },
  {
    key: '你好',
    value: 'Добрый день',
  },
  {
    key: '新消息',
    value: 'Уведомление',
  },
  {
    key: '临时保存订单',
    value: 'Черновик заказа',
  },
  {
    key: '临时保存的订单',
    value: 'Черновик заказа',
  },
  {
    key: '待处理订单',
    value: 'Все заказы',
  },
  {
    key: '等待工厂发货的订单',
    value: 'Заказы, по которым ожидается отправка товара с завода-изготовителя',
  },
  {
    key: '货物到达Sponlax中国仓库',
    value: 'Товар поступил на склад Sponlax в Китае',
  },
  {
    key: '质量控制和处理',
    value: 'Проверка качества и обработка',
  },
  {
    key: '国际运费报价',
    value: 'Установка цены на международную перевозку',
  },
  {
    key: '国际运费待支付',
    value: 'Ожидается оплата стоимости международной перевозки',
  },
  {
    key: '已入仓待装箱发货',
    value:
      'Товар уже поступил на склад для затаривания в контейнеры и отправки',
  },
  {
    key: '中国发往俄罗斯的订单',
    value: 'Заказы, отправляемые из Китая в Россию',
  },
  {
    key: '货物到达Sponlax俄罗斯仓库',
    value: 'Товар поступил на склад Sponlax в России',
  },
  {
    key: '西班牙派送',
    value: 'Доставка в России',
  },
  {
    key: '入库完了订单',
    value: 'Регистрация заказа на складе окончена',
  },
  {
    key: '需要付款的订单',
    value: 'Заказы, которые необходимо оплатить',
  },
  {
    key: '待支付国际运费',
    value: 'Ожидается оплата стоимости международной перевозки',
  },
  {
    key: '待报价',
    value: 'Ожидается установка цены',
  },
  {
    key: '待支付',
    value: 'Ожидается оплата',
  },
  {
    key: '已收货',
    value: 'Товар уже получен',
  },
  {
    key: '国际运费待报价',
    value: 'Ожидается установка цены на международную перевозку',
  },
  {
    key: '到达Sponlax物流中心',
    value: 'Прибытие в логистический центр Sponlax',
  },
  {
    key: '订单待处理',
    value: 'Все заказы',
  },
  {
    key: '订单到达Sponlax仓库',
    value: 'Заказ, прибыл на склад Sponlax',
  },
  {
    key: '订单运输中',
    value: 'Упаковочный лист',
  },
  {
    key: '已完成订单',
    value: 'Завершенные заказы',
  },
  {
    key: '发票',
    value: 'Инвойс',
  },
  {
    key: '历史发票',
    value: 'История инвойсов',
  },
  {
    key: '发票信息',
    value: 'Информация об инвойсах',
  },
  {
    key: '全名',
    value: 'Полное наименование',
  },
  {
    key: '店铺收藏',
    value: 'Избранные магазины',
  },
  {
    key: '电子邮箱',
    value: 'Адрес электронной почты',
  },
  {
    key: '发货地址',
    value: 'Адрес доставки товара',
  },
  {
    key: '密码修改与验证',
    value: 'Поменять пароль',
  },
  {
    key: '账户信息摘要',
    value: 'Краткая информация об аккаунте',
  },
  {
    key: '已发出的订单',
    value: 'Отправленные заказы',
  },
  {
    key: '佣金计算方法',
    value: 'Способ расчета платы за обслуживание',
  },
  {
    key: '优惠券',
    value: 'Купон',
  },
  {
    key: '重点订单信息',
    value: 'Информация об основных заказах',
  },
  {
    key: '已到达Sponlax仓库的订单',
    value: 'Заказы, прибывшие на склад Sponlax',
  },
  {
    key: '管理订单',
    value: 'Заказ',
  },
  {
    key: '订单状态概况',
    value: 'Сведения о статусе заказа',
  },
  {
    key: '待支付国际运费的订单',
    value:
      'Заказы, по которым ожидается оплата стоимости международной перевозки',
  },
  {
    key: '俄罗斯国内配送中',
    value: 'В процессе доставки по России',
  },
  {
    key: '已取消的订单',
    value: 'Отмененные заказы',
  },
  {
    key: '所有订单',
    value: 'Все заказы',
  },
  {
    key: '待收货',
    value: 'В ожидании отравки товара',
  },
  {
    key: '待处理的订单',
    value: 'Все заказы',
  },
  {
    key: '待付款的订单',
    value: 'Ожидание оплаты',
  },
  {
    key: '收件人',
    value: 'Получатель',
  },
  {
    key: '临时保存的',
    value: 'Временно сохраненные',
  },
  {
    key: '出货完成',
    value: 'Отгрузка товара завершена',
  },
  {
    key: '进口商',
    value: 'Импортер',
  },
  {
    key: '邮编',
    value: 'Почтовый индекс',
  },
  {
    key: '地址',
    value: 'Адрес',
  },
  {
    key: '编辑地址',
    value: 'Отредактировать адрес',
  },
  {
    key: '设为默认地址',
    value: 'Установить адрес по умолчанию',
  },
  {
    key: '是否删除当前地址?',
    value: 'Следует ли удалить текущий адрес?',
  },
  {
    key: '删除取消',
    value: 'Отмена удаления',
  },

  {
    key: '地址管理',
    value: 'Управление адресами',
  },
  {
    key: '操作成功',
    value: 'Операция выполнена успешно',
  },
  {
    key: '成功删除地址',
    value: 'Адрес успешно удален',
  },
  {
    key: '移除成功',
    value: 'Успешно удалено',
  },
  {
    key: '您已成功移除选中的商品',
    value: 'Вы успешно удалили выбранные товары',
  },
  {
    key: '重置',
    value: 'сброс',
  },
  {
    key: '添加',
    value: 'Добавить',
  },
  {
    key: '移除',
    value: 'Удалить',
  },
  {
    key: '选择标签',
    value: 'Выбрать тег',
  },
  {
    key: '请输入关键词',
    value: 'Пожалуйста, введите ключевые слова',
  },
  {
    key: '格式不正确',
    value: 'Неверный формат',
  },
  {
    key: '同步到收件人',
    value: 'Синхронизация с получателем',
  },
  {
    key: '密码验证',
    value: 'Подтверждение пароля',
  },
  {
    key: '确认关闭？',
    value: 'Подтвердить закрытие?',
  },
  {
    key: '请选择验证方式',
    value: 'Пожалуйста, выберите способ подтверждения',
  },
  {
    key: '身份验证',
    value: 'Аутентификация',
  },
  {
    key: '请输入登录密码',
    value: 'Пожалуйста, введите пароль для авторизации',
  },
  {
    key: '请输入旧登录密码',
    value: 'Пожалуйста, введите старый пароль для авторизации',
  },
  {
    key: '下一步',
    value: 'Следующий шаг',
  },
  {
    key: '密码错误',
    value: 'Неверный пароль',
  },
  {
    key: '登录密码修改',
    value: 'Изменение пароля для авторизации',
  },
  {
    key: '新密码',
    value: 'Новый пароль',
  },
  {
    key: '购买数量不能超过在库数量',
    value:
      'Приобретаемое количество не может превышать количество, имеющееся на складе',
  },
  {
    key: '再次确认密码',
    value: 'Подтвердите пароль еще раз',
  },
  {
    key: '请再次输入密码',
    value: 'Пожалуйста, введите пароль еще раз',
  },
  {
    key: '返回主页',
    value: 'Вернуться на стартовую страницу',
  },
  {
    key: '更改成功',
    value: 'Успешно изменено',
  },
  {
    key: '登录密码更改成功',
    value: 'Пароль для авторизации успешно изменен',
  },
  {
    key: '密码修改成功，请重新登录',
    value: 'Пароль успешно изменен. Пожалуйста, авторизируйтесь повторно',
  },
  {
    key: '当前未登录',
    value: 'На данный момент Вы не авторизированы',
  },
  {
    key: '其他认证方式',
    value: 'Прочие способы верификации',
  },
  {
    key: '请在60秒后重新发送验证码',
    value: 'Пожалуйста, повторно отправьте проверочный код через 60 секунд',
  },
  {
    key: '订单里请至少添加一款商品',
    value: 'Пожалуйста, добавьте хотя бы один товар в заказ',
  },
  {
    key: '时间',
    value: 'Время',
  },
  {
    key: '全选',
    value: 'Выбрать',
  },
  {
    key: '产品信息',
    value: 'Информация о товаре',
  },
  {
    key: '备注',
    value: 'Примечания',
  },
  {
    key: '店铺名/店铺',
    value: 'Название магазина/магазин',
  },
  {
    key: '店铺',
    value: 'Магазин',
  },
  {
    key: '选择附加服务',
    value: 'Выберите дополнительные услуги',
  },
  {
    key: '追加商品',
    value: 'Добавить товары',
  },
  {
    key: '删除',
    value: 'Удалить',
  },
  {
    key: '客户提现出金',
    value: 'Вывод денежных средств клиентом на банковскую карту',
  },
  {
    key: '客户提出现金',
    value: 'Клиент забирает денежные средства наличными',
  },
  {
    key: '产品费用',
    value: 'Стоимость товара',
  },
  {
    key: '其他费用',
    value: 'Другие расходы',
  },
  {
    key: '备注后会同步显示给业务员',
    value:
      'После того, как примечание будет сделано, оно будет одновременно отображено в службе поддержки клиентов.',
  },
  {
    key: '附加服务选项',
    value: 'Опции по выбору дополнительных услуг',
  },
  {
    key: '预计费用',
    value: 'Предварительная стоимость',
  },
  {
    key: '合计约为',
    value: 'Итоговая сумма составляет примерно',
  },
  {
    key: '出入金记录',
    value: 'Детализация счета',
  },
  {
    key: '确定',
    value: 'Подтвердить',
  },
  {
    key: '收件工资',
    value: 'Сдельная оплата труда по факту получения товара',
  },
  {
    key:
      '的发送：您已正确付款并且您的货物已在发送至我们的仓库。 商品到货时将提供国家快递（GLS）的追踪号码。您可以在个人中心中查看状态。',
    value:
      'Отправка: Вы оплатили правильно, и Ваш товар уже отправлен на наш склад. Когда товар прибудет, Вам будет предоставлен номер для отслеживания National Express (GLS). Вы можете проверить статус заказа в личном кабинете.',
  },
  {
    key: '有必填项未填写',
    value: 'Обязательные для заполнения поля не заполнены',
  },
  {
    key: '唛头',
    value: 'Маркировка',
  },
  {
    key: '请输入完整电子邮箱',
    value: 'Пожалуйста, введите полный адрес электронной почты',
  },
  {
    key: '联系我们',
    value: 'Связаться с нами',
  },
  {
    key: '汇款金额需要大于当前不足的金额',
    value:
      'Сумма перевода должна быть больше недостающей на данный момент суммы',
  },
  {
    key: '支付金额不能少于最低入金金额 ',
    value:
      'Сумма платежа не может быть меньше минимальной суммы входящего платежа',
  },
  {
    key: '余额不足',
    value: 'Баланса средств не достаточно',
  },
  {
    key: '提醒',
    value: 'Напоминание',
  },
  {
    key: '当前余额不足，是否前往充值',
    value:
      'Текущего остатка средств недостаточно, стоит ли перейти к пополнению счета',
  },
  {
    key: '删除订单',
    value: 'Удалить заказ',
  },
  {
    key:
      '当前订单商品暂无库存，无法完成购买。您可以调整订单重新提出 也可以直接删除该订单。',
    value:
      'Текущего товара для заказа нет в наличии,  покупка не может быть завершена. Вы можете скорректировать заказ подать его повторно, либо Вы можете напрямую удалить заказ.',
  },
  {
    key: '附加服务选择',
    value: 'Выбор дополнительных услуг',
  },
  {
    key: '该订单已正式提出，勿重复提出',
    value: 'Заказ был официально подан, не повторяйте его',
  },
  {
    key: '购物车为空',
    value: 'Корзина покупок пуста',
  },
  {
    key: '收藏夹',
    value: 'Папка для избранного',
  },
  {
    key: '调查在库数量',
    value: 'Узнайте количество товара на складе',
  },
  {
    key: '预计到货成本',
    value: 'Предполагаемая стоимость доставки',
  },
  {
    key: '特殊备注要求',
    value: 'Особые требования к примечаниям',
  },
  {
    key: '全部费用明细',
    value: 'Детализация всех расходов',
  },
  {
    key: '修改订单',
    value: 'Изменить заказ',
  },
  {
    key: 'Sponlax订单价值',
    value: 'Стоимость заказа Sponlax',
  },
  {
    key: '对该订单有特殊要求的，可以在这边备注',
    value:
      'Если у Вас имеются особые требования к этому заказу, Вы можете оставить примечание здесь',
  },
  {
    key: '重新提出',
    value: 'Вновь подать',
  },
  {
    key: '调查单价',
    value: 'Узнать цену за единицу',
  },
  {
    key: '关闭',
    value: 'Закрыть',
  },
  {
    key: '选择优惠券或代金券',
    value: 'Выбрать купон',
  },
  {
    key:
      '温馨提示：一个订单只能使用一张优惠券，优惠券适用于订单、代金券适用于配送单',
    value:
      'Напоминание: Для оформления заказа можно использовать только один купон. Скидочный купон применим к заказу, а платежный купон применим к сопроводительному документу.',
  },
  {
    key: '代金券',
    value: 'Платежный купон',
  },
  {
    key: '余额支付',
    value: 'Оплата остатком средств',
  },
  {
    key: '支付成功',
    value: 'Успешно оплачено',
  },
  {
    key: '汇款金额不能为空',
    value: 'Сумма перевода не может быть незаполнена',
  },
  {
    key: '请上传图片',
    value: 'Пожалуйста, загрузите изображение',
  },
  {
    key: '是否使用银行卡支付',
    value: 'Следует ли использовать для оплаты банковскую карту ',
  },
  {
    key: '付款流水号',
    value: 'Серийный номер платежа',
  },
  {
    key: '回到个人中心',
    value: 'Вернуться в личный кабинет',
  },
  {
    key: '汇款金额不能小于最低汇款金额',
    value:
      'Сумма перевода не может быть меньше минимальной суммы денежного перевода',
  },
  {
    key: '发货日期',
    value: 'Дата отправки товара',
  },
  {
    key: '包含订单',
    value: 'Включая заказы',
  },
  {
    key: '暂无单号',
    value: 'В настоящий момент номер заказа отсутствует',
  },
  {
    key: '配送单状态',
    value: 'Статус сопроводительного документа',
  },
  {
    key: '已确认付款',
    value: 'Оплата подтверждена',
  },
  {
    key: '俄罗斯派送时间',
    value: 'Время доставки в России',
  },
  {
    key: '中国国内运费',
    value: 'Стоимость перевозки внутри Китая',
  },
  {
    key: '国内',
    value: 'Внутри страны',
  },
  {
    key: '关税',
    value: 'Таможеная пошлина',
  },
  {
    key: '预计成本',
    value: 'Предполагаемые затраты',
  },
  {
    key: '税金',
    value: 'Сумма пошлины',
  },
  {
    key: '总成本',
    value: 'Итого',
  },
  {
    key: '目的地',
    value: 'Место назначения',
  },
  {
    key: '航运标志',
    value: 'Маркировка при доставке водным транспортом',
  },
  {
    key: '表格下载',
    value: 'Скачать бланк',
  },
  {
    key: '形式发票',
    value: 'Проформа-инвойс',
  },
  {
    key: '全选/取消',
    value: 'Выбрать все/отменить',
  },
  {
    key: '优惠金额',
    value: 'Сумма скидки',
  },
  {
    key: '支付金额',
    value: 'Сумма оплаты',
  },
  {
    key: '上架中',
    value: 'В процессе выставления на продажу',
  },
  {
    key: '金额',
    value: 'Сумма',
  },
  {
    key: '请输入支付金额',
    value: 'Пожалуйста, введите сумму оплаты',
  },
  {
    key: '单番合计',
    value: 'Итого',
  },
  {
    key: '订单',
    value: 'Заказы',
  },
  {
    key: '账户',
    value: 'Аккаунт',
  },
  {
    key: '前往登录',
    value: 'Перейти к авторизации',
  },
  {
    key: '请选择商品',
    value: 'Пожалуйста, выберите товары',
  },
  {
    key: '问题商品',
    value: 'Проблемные товары',
  },
  {
    key: '公司介绍',
    value: 'Профиль компании',
  },
  {
    key: '会员服务条款',
    value: 'Условия обслуживания членов',
  },
  {
    key: '用户指南',
    value: 'Руководство',
  },
  {
    key: '国际运费',
    value: 'Расходы на перевозку',
  },
  {
    key: '一般条款和条件',
    value: 'Общие положения и условия',
  },
  {
    key: '法律警告',
    value: 'Предупреждение от законодательства',
  },
  {
    key: '已付款待财务确认',
    value: 'Оплачено,в ожидании подтверждения финансовым отделом',
  },
  {
    key: '衣服',
    value: 'Одежда',
  },
  {
    key: '商品种类',
    value: 'Категории товаров',
  },
  {
    key: '海上运输',
    value: 'Перевозка морем',
  },
  {
    key: '操作菜单',
    value: 'Операционное меню',
  },
  {
    key: '全部的费用',
    value: 'Все расходы',
  },
  {
    key: '暂无优惠券',
    value: 'На данный момент скидочные купоны отсутствуют',
  },
  {
    key: '无佣金',
    value: 'Без комиссии',
  },
  {
    key: '中国国内所有费用',
    value: 'Все расходы на территории Китая',
  },
  {
    key: '商品价值',
    value: 'Стоимость товара',
  },
  {
    key: '俄罗斯物流预估',
    value: 'Предварительная оценка логистики на территории России',
  },
  {
    key: '反倾销税预估',
    value: 'Предварительное начисление антидемпинговой пошлины',
  },
  {
    key: '俄罗斯预估',
    value: 'Предварительная оценка на территории России',
  },
  {
    key: '问题图片',
    value: 'Фотографии возникших проблем',
  },
  {
    key: '问题产品细节',
    value: 'Подробности проблемного товара',
  },
  {
    key: '添加选中商品',
    value: 'Добавить выбранный товар',
  },
  {
    key: '可提货数量',
    value: 'Количество доступного к получению товара',
  },
  {
    key: '提示：配送单信息如有修改，请联系您的负责人员',
    value:
      'Напоминание: если имеются какие-либо изменения в информации, указанной в сопроводительном документе, пожалуйста, свяжитесь с Вашим ответственным лицом',
  },
  {
    key: '收货地址',
    value: 'Адрес получения товара',
  },
  {
    key: '请输入邮编',
    value: 'Пожалуйста, введите почтовый индекс',
  },
  {
    key: '请输入联系人',
    value: 'Пожалуйста, введите контактное лицо',
  },
  {
    key: '请输入手机',
    value: 'Пожалуйста, введите номер мобильного телефона',
  },
  {
    key: '请输入电子邮箱',
    value: 'Пожалуйста, введите адрес электронной почты',
  },
  {
    key: '请输入CNPJ',
    value: 'Пожалуйста, введите СNPJ',
  },
  {
    key: '收货地址详情',
    value: 'Подробная информация об адресе получения товара',
  },
  {
    key: 'Sponlax代通关',
    value: 'Sponlax выступает в роли посредника при таможенном оформлении',
  },
  {
    key: '俄罗斯物流费用',
    value: 'Плата за логистические услуги на территории России',
  },
  {
    key: '增值税',
    value: 'НДС',
  },
  {
    key: '反倾销税',
    value: 'Антидемпинговая пошлина',
  },
  {
    key: '提示文字',
    value: 'Текст предупреждения',
  },
  {
    key: '提交',
    value: 'Передать',
  },
  {
    key: '汇款图片不能为空',
    value: 'Изображение денежног перевода не может быть пустым',
  },
  {
    key: '修改唛头',
    value: 'Изменить маркировку',
  },
  {
    key: '修改SSN',
    value: 'Изменить SSN',
  },
  {
    key: '阿拉巴马州',
    value: 'Alabama',
  },
  {
    key: '阿拉斯加州',
    value: 'Alaska',
  },
  {
    key: '亚利桑那州',
    value: 'Arizona',
  },
  {
    key: '阿肯色州',
    value: 'Arkansas',
  },
  {
    key: '加利福尼亚州',
    value: 'California',
  },
  {
    key: '科罗拉多州',
    value: 'Colorado',
  },
  {
    key: '康涅狄格州',
    value: 'Connecticut',
  },
  {
    key: '德拉华州',
    value: 'Delaware',
  },
  {
    key: '(华盛顿)哥伦比亚特区',
    value: 'District of Columbia',
  },
  {
    key: '佛罗里达州',
    value: 'Florida',
  },
  {
    key: '乔治亚州',
    value: 'Georgia',
  },
  {
    key: '佐治亚州',
    value: 'Georgia',
  },
  {
    key: '夏威夷州',
    value: 'Hawaii',
  },
  {
    key: '爱达荷州',
    value: 'Idaho',
  },
  {
    key: '科罗拉多州',
    value: 'Colorado',
  },
  {
    key: '康涅狄格州',
    value: 'Connecticut',
  },
  {
    key: '德拉华州',
    value: 'Delaware',
  },
  {
    key: '(华盛顿)哥伦比亚特区',
    value: 'District of Columbia',
  },
  {
    key: '佛罗里达州',
    value: 'Florida',
  },
  {
    key: '乔治亚州',
    value: 'Georgia',
  },
  {
    key: '夏威夷州',
    value: 'Hawaii',
  },
  {
    key: '爱达荷州',
    value: 'Idaho',
  },
  {
    key: '特拉华州',
    value: 'Delaware',
  },
  {
    key: '伊利诺州',
    value: 'Illinois',
  },
  {
    key: '印地安那州',
    value: 'Indiana',
  },
  {
    key: '衣阿华州',
    value: 'Iowa',
  },
  {
    key: '堪萨斯州',
    value: 'Kansas',
  },
  {
    key: '肯塔基州',
    value: 'Kentucky',
  },
  {
    key: '路易斯安那州',
    value: 'Louisiana',
  },
  {
    key: '缅因州',
    value: 'Maine',
  },
  {
    key: '马里兰州',
    value: 'Maryland',
  },
  {
    key: '麻萨诸塞州',
    value: 'Massachusetts',
  },
  {
    key: '密执安州',
    value: 'Michigan',
  },
  {
    key: '明尼苏达州',
    value: 'Minnesota',
  },
  {
    key: '密西西比州',
    value: 'Mississippi',
  },
  {
    key: '密苏里州',
    value: 'Missouri',
  },
  {
    key: '蒙大拿州',
    value: 'Montana',
  },
  {
    key: '内布拉斯加州',
    value: 'Nebraska',
  },
  {
    key: '内华达州',
    value: 'Nevada',
  },
  {
    key: '新罕布什尔州',
    value: 'New Hampshire',
  },
  {
    key: '新泽西州',
    value: 'New Jersey',
  },
  {
    key: '新墨西哥州',
    value: 'New Mexico',
  },
  {
    key: '纽约州',
    value: 'New York',
  },
  {
    key: '北卡罗来纳州',
    value: 'North Carolina',
  },
  {
    key: '北达科他州',
    value: 'North Dakota',
  },
  {
    key: '俄亥俄州',
    value: 'Ohio',
  },
  {
    key: '俄克拉荷马州',
    value: 'Oklahoma',
  },
  {
    key: '宾夕法尼亚州',
    value: 'Pennsylvania',
  },
  {
    key: '俄勒冈州',
    value: 'Oregon',
  },
  {
    key: '罗得岛州',
    value: 'Rhode Island',
  },
  {
    key: '南达科他州',
    value: 'South Dakota',
  },
  {
    key: '内布拉斯加州',
    value: 'South Carolina',
  },
  {
    key: '南卡罗来纳州',
    value: 'South Carolina',
  },
  {
    key: '田纳西州',
    value: 'Tennessee',
  },
  {
    key: '德克萨斯州',
    value: 'Texas',
  },
  {
    key: '犹他州',
    value: 'Utah',
  },
  {
    key: '佛蒙特州',
    value: 'Vermont',
  },
  {
    key: '弗吉尼亚州',
    value: 'Virginia',
  },
  {
    key: '华盛顿州',
    value: 'Washington',
  },
  {
    key: '西弗吉尼亚州',
    value: 'West Virginia',
  },
  {
    key: '威斯康星州',
    value: 'Wisconsin',
  },
  {
    key: '怀俄明州',
    value: 'Wyoming',
  },
  {
    key: '请输入邮箱',
    value: 'Пожалуйста, введите адрес электронной почты',
  },
  {
    key: '选择',
    value: 'Выберите',
  },
  {
    key: '请填写验证码',
    value: 'Пожалуйста, введите проверочный код',
  },
  {
    key: '填写信息',
    value: 'Заполните информацию',
  },
  {
    key: '俄罗斯',
    value: 'Россия',
  },
  {
    key: '请输入验证码',
    value: 'Пожалуйста, введите проверочный код',
  },
  {
    key: '使用条款和隐私政策还没有被同意。',
    value:
      'Условия использования и политика конфиденциальности еще не были согласованы.',
  },
  {
    key: '返回重新编辑',
    value: 'Вернуться и отредактировать заново',
  },
  {
    key: '暂无库存',
    value: 'На данный момент нет остатков на складе',
  },
  {
    key: '秒后可重新发送验证码',
    value: 'Проверочный код можно отправить повторно через секунду',
  },
  {
    key: '费用(₽)',
    value: 'Расходы (₽)',
  },
  {
    key: '箱号',
    value: ' Номер коробки',
  },
  {
    key: '长',
    value: 'Длина',
  },
  {
    key: '宽',
    value: 'Ширина',
  },
  {
    key: '番号',
    value: 'Номер',
  },
  {
    key: '装箱数量',
    value: 'Количество коробок',
  },
  {
    key: '请选择预设收货地址',
    value:
      'Пожалуйста, выберите установленный по умолчанию адрес получения товара',
  },
  {
    key: '欢迎光临Sponlax',
    value: 'Добро пожаловать в Sponlax',
  },
  {
    key: '销量',
    value: 'Объем продаж',
  },
  {
    key: '是否登录',
    value: 'Авторизироваться?',
  },
  {
    key: '是否前往登录?',
    value: 'Перейти к авторизации?',
  },
  {
    key: '是否提交充值信息？',
    value: 'Передать информацию о пополнении?',
  },
  {
    key: '请选择预设进口商',
    value: 'Пожалуйста, выберите указанного по умолчанию импортера',
  },
  {
    key: '该商品因库存不足或其他原因已经找不到，请查看其他商品！',
    value:
      'Данный товар не удалось найти из-за недостаточного количества на складе или по другим причинам, пожалуйста, посмотрите другие товары!',
  },
  {
    key: '返回首页',
    value: 'Вернуться на стартовую страницу',
  },
  {
    key: '已使用代金券',
    value: 'Платежный купон применен',
  },
  {
    key: '俄罗斯物流发货时间',
    value: 'Время отправки товара логистической компанией в России',
  },
  {
    key: '俄罗斯国内运输费用',
    value: 'Стимость перевозки на территории России',
  },
  {
    key: '已删除',
    value: 'Удалено',
  },
  {
    key: '已删除(订单状态)',
    value: 'Удалено (статус заказа)',
  },
  {
    key: '已使用',
    value: 'Использовано',
  },
  {
    key: '装箱信息',
    value: 'Информация об упаковке в контейнер',
  },
  {
    key: '电子邮箱修改',
    value: 'Изменение адреса электронной почты',
  },
  {
    key: '手机号修改',
    value: 'Изменение номера мобильного телефона',
  },
  {
    key: '手机号输入错误',
    value: 'Ошибка ввода мобильного телефона',
  },
  {
    key: '提出订单',
    value: 'Подать заказ',
  },
  {
    key: '全部费用',
    value: 'Все расходы',
  },
  {
    key: '附加服务费',
    value: 'Стоимость добавленных дополнительных услуг',
  },
  {
    key: '选择国际运输公司',
    value: 'Выберите компанию по международным перевозкам',
  },
  {
    key: '选择代金券',
    value: 'Выберите платежный купон',
  },
  {
    key: '选择优惠券',
    value: 'Выберите скидочный купон',
  },
  {
    key: '请选择您的物流方式，不同的物流方式价格不同',
    value:
      'Пожалуйста, выберите свой способ логистики, на разные способы логистики установлены разные цены',
  },
  {
    key: '特殊要求备注',
    value: 'Примечания по особым требованиям',
  },
  {
    key: '保存',
    value: 'Сохранить',
  },
  {
    key: '人民币',
    value: 'Китайские юани',
  },
  {
    key: '取消',
    value: 'Отменить',
  },
  {
    key: '联系人',
    value: 'Контактное лицо',
  },
  {
    key: '详情',
    value: 'Подробности',
  },
  {
    key: '付款',
    value: 'Оплата',
  },
  {
    key: '使用优惠券',
    value: 'Использовать скидочный купон',
  },
  {
    key: '查看全部',
    value: 'Смотреть все',
  },
  {
    key: '工作人员回复',
    value: 'Ответ сотрудника',
  },
  {
    key: '单番中国所有费用',
    value: 'Все расходы в Китае за отдельный товар',
  },
  {
    key: '暂时没有可使用的代金券',
    value: 'На данный момент нет доступных платежных купонов',
  },
  {
    key: '编号',
    value: 'Номер',
  },
  {
    key: '免手续费、无佣金',
    value: 'Без платы за услуги, без комисии',
  },
  {
    key: '已使用优惠',
    value: 'Скидочный купон применен',
  },
  {
    key: '是否使用余额支付?',
    value: 'Использовать остаток средств на балансе для оплаты?',
  },
  {
    key: '已取消支付',
    value: 'Оплата отменена',
  },
  {
    key: '确认付款',
    value: 'Подтвердить оплату',
  },
  {
    key: '请输入订单号搜索',
    value: 'Пожалуйста, введите номер заказа для поиска',
  },
  {
    key: '备注不能为空',
    value: 'Примечание не может быть незаполненным',
  },
  {
    key: '图片上传中',
    value: 'Изображение загружается',
  },
  {
    key: '汇款金额不能小于订单金额',
    value: 'Сумма денежного перевода не может быть меньше суммы заказа',
  },
  {
    key: '中国费用',
    value: 'Итог местных расходов',
  },
  {
    key: '您即将查看配送单的详细内容，您可以在当前界面查看国际运费的报价信息。',
    value:
      'Вы собираетесь просмотреть подробную информацию, содержащуюся в сопроводительном документе. Вы можете просмотреть информацию о тарифе на международные перевозки на текущей странице интерфейса.',
  },
  {
    key:
      '（因为客户直接调整将导致产品的实际包装数据异常，我们限制了客户直接调整交付订单的功能，请谅解。）',
    value:
      '(Поскольку прямая корректировка клиентом приведет к изменению фактических данных для упаковки товара, мы ограничили функцию прямой корректировки заказа клиентом, пожалуйста, приносим свои извинения и надеемся на Ваше понимание.)',
  },
  {
    key:
      '确认无误后，您可以点击"去付款"进行支付。确认收款后，我们将安排物流发货。物流更进详情将通过邮件发给您。如果您需要调整产品包装等，请将详细信息发送给我们。根据您的修改要求进行调整后，我们将提供新的报价。',
    value:
      'После подтверждения правильности ввода вы можете нажать "Перейти к оплате", чтобы произвести платеж. После подтверждения оплаты мы организуем логистику и отправку товара. Дальнейшая информация о логистике будет выслана Вам на электронную почту. Если Вам нужно внести коррективы в  упаковку продукта и т.д., пожалуйста, пришлите нам подробную информацию. После корректировки в соответствии с Вашими требованиями об изменениях мы предоставим Вам новое ценовое предложе',
  },

  {
    key: '汇率',
    value: ' Курс.',
  },
  {
    key: '俄罗斯物流成本',
    value: 'Стоимость логистических услуг на территории России',
  },
  {
    key: '订单备注',
    value: 'Примечания к заказу',
  },
  {
    key: '运货方式',
    value: 'Способ доставки',
  },
  {
    key: '销售合同',
    value: 'Договор купли-продажи',
  },
  {
    key: '产品成本',
    value: 'Расходы на товар',
  },
  {
    key: '预估国际运费',
    value: 'Предварительная стоимость услуг по международной перевозке',
  },
  {
    key: '预估俄罗斯国内运输',
    value:
      'Предварительная оценка стоимости услуг по перевозке на территории России',
  },
  {
    key: '总体积',
    value: 'Общий объем',
  },
  {
    key: '总价',
    value: 'Общая стоимость',
  },
  {
    key: '实际支付金额',
    value: 'Фактически оплаченная сумма',
  },
  {
    key: '费用明细',
    value: 'Детализация расходов',
  },
  {
    key: '体积',
    value: 'Объем',
  },
  {
    key: '重量',
    value: 'Вес',
  },
  {
    key: '单番合计',
    value: 'Итого по отдельным товарам',
  },
  {
    key: '内容',
    value: 'Содержание',
  },
  {
    key: '国内物流状态',
    value: 'Статус логистики внутри страны',
  },
  {
    key: '个人资料',
    value: 'Персональные данные',
  },
  {
    key: '初学者指南',
    value: 'Руководство для новых пользоватей',
  },
  {
    key: '关于公司',
    value: 'О компании',
  },
  {
    key: '隐私政策',
    value: 'Политика кофиденциальности',
  },
  {
    key: '表格',
    value: 'Бланк',
  },
  {
    key: '请输入正确的手机号',
    value: 'Пожалуйста, введите корректный номер мобильного телефона',
  },
  {
    key: '常见问题解答',
    value: 'Часто задаваемые вопросы',
  },
  {
    key: '是否使用在线支付？',
    value: 'Хотите ли Вы воспользоваться функцией онлайн платежа?',
  },
  {
    key: '加载中',
    value: 'В процессе загрузки',
  },
  {
    key: '共',
    value: 'Всего',
  },
  {
    key: '个产品',
    value: 'Штук товаров',
  },
  {
    key: '数量总计',
    value: 'Общее количество',
  },
  {
    key: '商品库',
    value: 'Каталог товаров',
  },
  {
    key: '卢布',
    value: 'Российских рублей',
  },
  {
    key: '国际物流预估',
    value: 'Предварительная стоимость международных логистических услуг',
  },
  {
    key: '俄罗斯物流预估',
    value: 'Предварительная стоимость логистических услуг на территории России',
  },
  {
    key: '增值税预估',
    value: 'Предварительная оценка суммы НДС',
  },
  {
    key: '预计总成本',
    value: 'Предварительная совокупная стоимость затрат',
  },
  {
    key: '全部费用预估',
    value: 'Предварительная оценка всех расходов',
  },
  {
    key: '负责人回复',
    value: 'Ответ службы поддержки',
  },
  {
    key: '国际船运A',
    value: 'Международные перевозки морем A',
  },
  {
    key: '名称',
    value: 'Наименование',
  },
  {
    key: '计费数据',
    value: 'Данные о подсчете расходов',
  },
  {
    key: '提出数',
    value: 'Предъявленное количество',
  },
  {
    key: '提货数量',
    value: 'Количество предъявленного к получению товара',
  },
  {
    key: '费用总计',
    value: 'Общая стоимость расходов',
  },
  {
    key: '收件公司',
    value: 'Компания-получатель',
  },
  {
    key: '请输入收件公司',
    value: 'Пожалуйста, введите компанию-получателя',
  },
  {
    key: '请输入地址',
    value: 'Пожалуйста, введите адрес',
  },
  {
    key: '请输入电话',
    value: 'Пожалуйста, введите номер телефона',
  },
  {
    key: '个人通关',
    value: 'Таможенное оформление от имени физического лица',
  },
  {
    key: '待处理',
    value: 'Ожидает обработку',
  },
  {
    key: '日期',
    value: 'Дата',
  },
  {
    key: '余额',
    value: 'Баланс',
  },
  {
    key: '修改姓氏',
    value: 'Изменить фамилию',
  },
  {
    key: '确认修改',
    value: 'Подтвердить изменения',
  },
  {
    key: '修改名字',
    value: 'Изменить имя',
  },
  {
    key: '邮箱地址',
    value: 'Адрес электронной почты',
  },
  {
    key: '确认关闭?',
    value: 'Подтвердить закрытие?',
  },
  {
    key: '付款后账户剩余',
    value: 'Баланс на счете после оплаты',
  },
  {
    key: '请上传支付截图',
    value: 'Пожалуйста, загрузите скрин-шот оплаты',
  },
  {
    key: '请选择州',
    value: 'Пожалуйста, выберите область/край',
  },
  {
    key: '姓氏长度不能大于24位',
    value: 'Длина фамилии не может превышать 24 символа',
  },
  {
    key: '西班牙',
    value: 'Россия',
  },
  {
    key: '请输入登录名',
    value: 'Пожалуйста, введите свое имя для входа',
  },
  {
    key: '发送方式',
    value: 'Способ отправки',
  },
  {
    key: '物流单号',
    value: 'Трекинг-номер',
  },
  {
    key: '费用(₽)',
    value: 'Стимость(₽)',
  },
  {
    key: '实际重量',
    value: 'Фактический вес',
  },
  {
    key: '高',
    value: 'Высота',
  },
  {
    key: '当前箱号',
    value: 'Текущий номер контейнера',
  },
  {
    key: '注意',
    value: 'Внимание',
  },
  {
    key: '图片',
    value: 'Картинка',
  },
  {
    key: '如果您想要修改配送单信息，请联系您的负责人员',
    value:
      'Если Вы хотите изменить информацию, содержащуются в сопроводительном документе, обратитесь в службу поддержки клиентов.',
  },
  {
    key: '已付款待确认',
    value: 'Оплачено, в ожидании подтверждения',
  },
  {
    key: '前往付款',
    value: 'Перейти к оплате',
  },
  {
    key: '操作失败',
    value: 'Ошибка в проведении операции',
  },
  {
    key: '邮箱、手机号或密码输入错误',
    value:
      'Адрес электронной почты, номер мобильного телефона или пароль введены неверно',
  },
  {
    key: '邮箱',
    value: 'Электронная почта',
  },
  {
    key: '是否确认删除？',
    value: 'Подтвердить удаление?',
  },
  {
    key: '已使用优惠券',
    value: 'Купон применен',
  },
  {
    key: '清关时间',
    value: 'Время таможенного оформления',
  },
  {
    key: '未达到使用条件',
    value: 'Условия использования не соблюдены',
  },
  {
    key: '摄影',
    value: 'Фотосъёмка',
  },
  {
    key: '摄影服务',
    value: 'Услуги по фотосъёмке',
  },
  {
    key: '贴条形码',
    value: 'Прикрепить штрих-код',
  },
  {
    key: '配套',
    value: 'Комплектация',
  },
  {
    key: '取布标',
    value: 'Получить тканевую этикетку',
  },
  {
    key: '缝布标',
    value: 'Пришить тканевую этикетку',
  },
  {
    key: '挂吊牌',
    value: 'Повесить бирку',
  },
  {
    key: '取吊牌',
    value: 'Получить бирку',
  },
  {
    key: '更换OPP袋',
    value: 'Сменить пластиковый пакет OOP',
  },
  {
    key: '气泡膜包装',
    value: 'Упаковка из пузырчатой ​​пленки',
  },
  {
    key: '单面印刷',
    value: 'Односторонняя печать',
  },
  {
    key: '双面印刷',
    value: 'Двусторонняя печать',
  },
  {
    key: '金额变动明细',
    value: 'Детализация изменения денежных средств',
  },
  {
    key: '元/个',
    value: 'юаней/штука',
  },
  {
    key: '元/张',
    value: 'юаней/штука',
  },
  {
    key: '点击查看详情',
    value: 'Нажмите, чтобы посмотреть подробности',
  },
  {
    key: '包括装OPP袋或者换OPP袋',
    value: 'Включая упаковку в пластиковый пакет OPP или замену пакета OPP',
  },
  {
    key: '4种商品以上配套手续费另行商谈',
    value:
      'Для более чем 4 видов товаров комиссия за услуги оговаривается отдельно.',
  },
  {
    key: '请参照右侧图片',
    value: 'Пожалуйста, обратитесь к изображению справа',
  },
  {
    key: '默认为A4纸张，其它类型纸张或小册子印刷请另行商谈',
    value:
      'По умолчанию используется бумага формата А4. Другие типы бумаги или печать буклетов оговариваются отдельно.',
  },
  {
    key: '默认到货商品检查项目',
    value: 'Пункты проверки для поступающего товара по умолчанию',
  },
  {
    key: '产品是否按订单发货',
    value: 'Отправлен ли товар в соответствии с заказом',
  },
  {
    key: '外观有无损坏',
    value: 'Нанесены ли повреждения внешнему виду?',
  },
  {
    key: '产品页面与产品是否存在较大差异？',
    value:
      'Имеется ли существенная разница между страницей, на которой размещен товар и самим товаром?',
  },
  {
    key:
      '我们将针对到货的商品主要针对以上三点进行检查，问题的商品，我们将向客户反馈。',
    value:
      'В основном мы проверяем прибывающие товары по трем вышеуказанным пунктам. Если есть какие-либо проблемные товары, мы предоставим клиентам обратную связь.',
  },
  {
    key: '大件商品请另行商谈',
    value: 'По крупногабаритным товарам просьба договариваться отдельно.',
  },
  {
    key: '操作内容',
    value: 'Содержание операции',
  },
  {
    key:
      '系统将根据您在本网站上累计出货的商品金额来决定手续费等级。不同的已出货的商品金额，对应着不同的会员等级。详情请参考下面的表格明细。',
    value:
      'Система определит уровень комиссии за услуги на основе количества товаров, которые Вы отгрузили на этом веб-сайте. Разные суммы, на которые отгружены товары соответствуют разным уровням членства. Пожалуйста, обратитесь к таблице ниже для получения подробной информации.',
  },
  {
    key:
      '例如：您累计出货的商品金额超过50,000欧元，您之后再下的订单手续费比例将变为9％。',
    value:
      'Например: если общая сумма стоимости отгруженных Вами товаров превышает 50 000 евро, коэффициент комисионного сбора за обработку заказа, который Вы разместите в дальнейшем, составит 9%.',
  },
  {
    key: '采购商品金额',
    value: 'Сумма стоимости приобретенных товаров',
  },
  {
    key: '签收时间',
    value: 'Время получения',
  },
  {
    key: '海关',
    value: 'Таможня',
  },
  {
    key: '已通关',
    value: 'Уже прошел таможню',
  },
  {
    key: '商品调整',
    value: 'Корректировка товаров',
  },
  {
    key: '已收货并检品完成',
    value: 'Товар уже получен и проверка товара завершена',
  },
  {
    key: '已打款',
    value: 'Уже оплачено',
  },
  {
    key: '邮箱更改成功',
    value: 'Адрес электронной почты успешно изменен',
  },
  {
    key: '是否同步到进口商',
    value: 'Следует ли синхронизироваться с импортером',
  },
  {
    key: '是否同步到收件人',
    value: 'Следует ли синхронизироваться с получателем',
  },
  {
    key: '您可以在这边添加商品备注',
    value: 'Здесь Вы можете добавить примечания к товару',
  },
  {
    key: '该订单状态不可支付',
    value: 'Статус данного заказа не может быть оплачен',
  },
  {
    key: '该配送单状态不可支付',
    value: 'Статус данного сопроводительного документа не может быть оплачен',
  },
  {
    key: 'Для редактирования',
    value: '1',
  },
  {
    key: '自动签收时间',
    value: 'Время автоматического получения',
  },
  {
    key: '同意',
    value: 'Согласие',
  },
  {
    key: '可用',
    value: 'Применимо',
  },
  {
    key: '过期',
    value: 'Просрочено',
  },
  {
    key: '已过期',
    value: 'Уже просрочено',
  },
  {
    key: '有效期',
    value: 'Период действия',
  },
  {
    key: '今日到期',
    value: 'Срок действия истекает сегодня',
  },
  {
    key: '订单金额',
    value: 'Сумма заказа',
  },
  {
    key: '店铺加载中',
    value: 'Магазин в процессе загрузки',
  },
  {
    key: '请输入6-16位包含大小写字母和数字的密码',
    value:
      'Пожалуйста, введите пароль длиной 6–16 символов, содержащий прописные и строчные буквы и цифры.',
  },
  {
    key: '提出配送单请将地址填写完整',
    value:
      'При оформлении сопроводительного документа, пожалуйста, указывайте адрес полностью.',
  },
  {
    key: '提出数不能超过可提出数',
    value:
      'Предъявленное количество товара к получению не может превышать количество доступного к получению товара',
  },
  {
    key: '此店铺暂无商品',
    value: 'В данном магазине на текущий момент товары отсутствуют',
  },
  {
    key: '选择通关方式',
    value: 'Выберите способ прохождения таможенного контроля',
  },
  {
    key: '立即生成',
    value: 'Немедленно сгенерировать',
  },
  {
    key: '点击选择附加服务',
    value: 'Нажмите, чтобы выбрать дополнительные услуги',
  },
  {
    key: '未查找到该账号，请核对后再尝试或联系客服处理',
    value:
      'Аккаунт не найден. Проверьте правильность вводимых данных и повторите попытку или обратитесь в службу поддержки клиентов.',
  },
  {
    key: '发票上传',
    value: 'Загрузить инвойс',
  },
  {
    key: '已发货',
    value: 'Товар уже отправлен',
  },
  {
    key: '双清包税',
    value: 'Уплата налогов за двойное таможенное оформление',
  },
  {
    key: '自行交税通关',
    value: 'Самостоятельная оплата налогов и таможенное оформление',
  },
  {
    key: '描述',
    value: 'Описание',
  },
  {
    key: '同意规约，完成注册',
    value: 'Согласиться с условиями и завершить регистрацию',
  },
  {
    key: 'Sponlax商品采购服务的描述',
    value: 'Описание услуг по закупкам товаров Sponlax',
  },
  {
    key: '通用操作程序的描述',
    value: 'Описание общего порядка проведения рабочих процедур',
  },
  {
    key: '客户个人中心的功能描述',
    value: 'Описание функций личного кабинета клиентов',
  },
  {
    key: '提现金额不可大于当前账户余额',
    value:
      'Сумма вывода денежных средств не может превышать текущий баланс счета',
  },
  {
    key: '客户提现',
    value: 'Вывод денежных средств клиентом',
  },
  {
    key: '俄罗斯物流单号',
    value: 'Трекинг-номер в России',
  },
  {
    key: '俄罗斯物流方式',
    value: 'Способ логистики в России',
  },
  {
    key: '是否取消当前订单?',
    value: 'Следует ли отменить текущий заказ?',
  },
  {
    key: '收件地址',
    value: 'Адрес получения товара',
  },
  {
    key: '签收',
    value: 'Расписаться в получении',
  },
  {
    key: '是否签收选中的商品？',
    value: 'Следует ли расписаться в получении выбранного товара?',
  },
  {
    key: '签收成功',
    value: 'Роспись в получении успешно произведена',
  },
  {
    key: '手机号更改成功',
    value: 'Номер мобильного телефона успешно изменен',
  },
  {
    key: '加入商品库成功',
    value: 'Успешно добавлен в лист товаров',
  },
  {
    key: '最低汇款金额',
    value: 'Минимальная сумма денежного перевода',
  },
  {
    key: '商品库为空',
    value: 'Лист товаров пуст',
  },
  {
    key: '已取消签收',
    value: 'Роспись в получении отменена',
  },
  {
    key: '查看更多',
    value: 'Смотреть больше',
  },
  {
    key: '注册帐户',
    value: 'Зарегистрировать аккаунт',
  },
  {
    key: '视频介绍',
    value: 'Ознакомительное видео',
  },
  {
    key: '搜索产品',
    value: 'Поиск товара',
  },
  {
    key: '如何下订单',
    value: 'Как сделать заказ',
  },
  {
    key: '如何提交交付请求',
    value: 'Как отправить запрос на доставку',
  },
  {
    key: '订单付款',
    value: 'Оплата заказа',
  },
  {
    key: '修改订单和交货订单',
    value: 'Изменение заказа и заказа на доставку',
  },
  {
    key: '发票生成失败，请检查您是否有默认地址，如无法解决，请直接联系负责人',
    value:
      'Не удалось создать инвойс. Проверьте, установлен ли у Вас адрес по умолчанию. Если проблему решить невозможно, обратитесь напрямую к ответственному лицу.',
  },
  {
    key: '资本项目',
    value: 'Счет операций с денежными средствами',
  },
  {
    key: '最喜欢的',
    value: 'Избранное',
  },
  {
    key: '个人数据',
    value: 'Персональные данные',
  },
  {
    key: '国家运输',
    value: 'Перевозка по стране',
  },
  {
    key: '与费用支付有关的问题',
    value: 'Вопросы, связанные с оплатой',
  },
  {
    key: '货物运输的清关问题',
    value: 'Вопросы, связанные с таможенным оформлением при перевозке грузов',
  },
  {
    key: '关于商店和产品',
    value: 'О магазинах и товарах',
  },
  {
    key: '货物的售后加工',
    value: 'Послепродажная обработка товаров',
  },
  {
    key: '规则协议',
    value: 'Соглашение о правилах',
  },
  {
    key: '俄罗斯国内物流',
    value: 'Внутренняя логистика в России',
  },
  {
    key: '国际物流',
    value: 'Международная логистика',
  },
  {
    key: '全部通知',
    value: 'Все уведомления',
  },
  {
    key: '已读',
    value: 'Прочитано',
  },
  {
    key: '未读',
    value: 'Непрочитано',
  },
  {
    key: '通知',
    value: 'Уведомление',
  },
  {
    key: '是否确认删除选中的通知',
    value: 'Подтвердить удаление выбранного уведомления?',
  },
  {
    key: '免手续费-1次',
    value: 'Без необходимости оплаты комиссионного сбора-1 раз',
  },
  {
    key: '删除(购物车)',
    value: 'Удалить (корзина покупок)',
  },
  {
    key: '不能全由空格组成',
    value: 'Не может полностью состоять из пробелов',
  },
  {
    key: '删除提示',
    value: 'Наминание при удалении',
  },
  {
    key: '提交失败',
    value: 'Ошибка при передаче',
  },
  {
    key: '提现成功',
    value: 'Вывод средств успешно завершен',
  },
  {
    key: '国际运费模拟',
    value: 'Конструктор международных перевозок',
  },
  {
    key: '估计物流成本',
    value: 'Предполагаемые затраты на логистику',
  },
  {
    key: '估计重量(KG)',
    value: 'Предполагаемый вес (КГ)',
  },
  {
    key: '预计商品总体积（m³）',
    value: 'Предполагаемый общий объем товара (м3)',
  },
  {
    key: '重新输入',
    value: 'Ввести повторно',
  },
  {
    key: '计算',
    value: 'Рассчитать',
  },
  {
    key: '预计国际运费:',
    value: 'Предполагаемая стоимость расходов на международную перевозку:',
  },
  {
    key: '预计总物流成本:',
    value: 'Предполагаемая общая стоимость логистических услуг:',
  },
  {
    key: '税号/身份证号',
    value: 'ИНН/номер удостоверения личности',
  },
  {
    key: '公司简介',
    value: 'Профиль компании',
  },
  {
    key: '在俄罗斯的估计运费:',
    value: 'Предполагаемая стоимость расходов на перевозку по России:',
  },
  {
    key: '工作日上午 9:00 至下午 6:00',
    value: 'Рабочие часы: Пн-Пт, с 9:00 до 18:00 (CST)',
  },
  {
    key: '以客户为中心',
    value: 'Ориентированность на клиентов',
  },
  {
    key: '提出数量不能小于1',
    value: 'Предъявленное количество не может быть меньше 1',
  },
  {
    key: '请输入关键词、1688商品链接或通过图片搜索',
    value:
      'Пожалуйста, введите ключевые слова, ссылку на товар с сайта 1688 или выполните поиск по изображению',
  },
  {
    key: '公司',
    value: 'Компания',
  },
  {
    key: '法律条件',
    value: 'Правовые условия',
  },
  {
    key: 'Cookie 政策',
    value: 'Политика использования файлов cookie',
  },
  {
    key: '支持',
    value: 'Поддержка',
  },
  {
    key: '免费注册',
    value: 'Бесплатная регистрация',
  },
  {
    key: '订单跟踪',
    value: 'Отслеживание заказов',
  },
  {
    key: '州',
    value: 'Зона',
  },
  {
    key: '信息和费率',
    value: 'Информация и тарифы',
  },
  {
    key: '费用和佣金',
    value: 'Плата и комиссионный сбор',
  },
  {
    key: '请选择地区',
    value: 'Пожалуйста, выберите регион',
  },
  {
    key: '退货和退款',
    value: 'Возвраты товаров и вовраты денежных средств',
  },
  {
    key: '会员服务(页脚)',
    value: 'Служба поддержки членов (сноска)',
  },
  {
    key: '摄影服务(页脚)',
    value: 'Услуги фотосъемки (сноска)',
  },
  {
    key: '其他',
    value: 'Прочее',
  },
  {
    key: '成为Sponlax的会员',
    value: 'Станьте членом Sponlax',
  },
  {
    key: '搜索并支付产品的第一次付款',
    value: 'Найдите товар и оплатите его в первый раз',
  },
  {
    key: '质量控制和储存在我们的中国仓库',
    value: 'О контроле качества и хранении на складе Sponlax в Китае',
  },
  {
    key: '关于我们',
    value: 'О нас',
  },
  {
    key: '国际',
    value: 'Международный',
  },
  {
    key: '第二次支付运费和国际航运',
    value: 'Повторная оплата услуг по перевозке и международной доставки морем',
  },
  {
    key: '遵循运输过程并接收您的产品',
    value: 'Проследите за процессом доставки и получите свой товар',
  },
  {
    key: '现在入住',
    value: 'Сейчас аккредитирован',
  },
  {
    key: '推荐商品',
    value: 'Рекомендуемые товары',
  },
  {
    key: '给你的建议',
    value: 'Рекомендации для Вас',
  },
  {
    key: '您的备注会同步展示给工作人员',
    value: 'Ваши примечания будут одновременно отображены сотрудникам',
  },
  {
    key: '查看更多类别',
    value: 'Просмотр большего количества категорий',
  },
  {
    key: '特殊要求备注',
    value: 'Примечания по особым требованиям',
  },
  {
    key: '*需求especiales',
    value: '*Особые требования',
  },
  {
    key:
      '您可以写下您对产品的任何服务和要求，例如定制包装盒产品定制等。我们的工作人员将会联系您并商讨细节',
    value:
      'Вы можете записать любые услуги и требования, которые  Вы желаете получить в отношении товара, такие как сделанные на заказ упаковочные коробки, изготовление товара на заказ и т.д.Наши сотрудники свяжутся с Вами и обсудят детали.',
  },
  {
    key: '*您的备注会同步展示给工作人员',
    value: '* Ваши примечания будут одновременно отображены сотрудникам',
  },
  {
    key:
      '我们根据订单总额收取佣金。对于每个金额，都有特定百分比的佣金。请参阅下表，了解您的订单将低于多少百分比。',
    value:
      'Мы взимаем комиссию за обработку заказа в зависимости от общей оплачиваемой суммы заказа. Разные суммы соответствуют комиссионным ставкам разного уровня. Пожалуйста, ознакомьтесь с таблицей ниже, чтобы узнать комиссионную ставку, соответствующую сумме Вашего заказа.',
  },
  {
    key: '全部费用',
    value: 'Полная стоимость',
  },
  {
    key: '产品费用细目',
    value: 'Детализация расходов на товар',
  },
  {
    key: '佣金说明',
    value: 'Описание платы за обслуживание',
  },
  {
    key: '额外服务',
    value: 'Дополнительные услуги',
  },
  {
    key: '估计国际运费',
    value: 'Предполагаемая стоимость расхожов на международную перевозку',
  },
  {
    key: '预计交货时间',
    value: 'Предполагаемый срок доставки',
  },
  {
    key: '估计总进口成本(包括物流和税收)的成本细目',
    value:
      'Разбивка предполагаемой общей стоимости на импорт (включая логистику и налоги)',
  },
  {
    key: '估计国际运输',
    value: 'Предполагаемая международная перевозка',
  },
  {
    key: '对俄罗斯的估计',
    value: 'Оценка по России',
  },
  {
    key: '估计反倾销税',
    value: 'Предполагаемая антидемпинговая пошлина',
  },
  {
    key: '估计增值税',
    value: 'Предполагаемый НДС',
  },
  {
    key: '估计总开支',
    value: 'Предполагаемый общий объем расходов',
  },
  {
    key: '为什么现在估计装运?',
    value: 'Почему стоимость отгрузки оценивается именно сейчас?',
  },
  {
    key:
      'Чтобы предоставить наилучшее предложение по импорту, как только товар поступит на наш склад, будет рассчитана точная стимость перевозки и стоимость других затрат, поэтому на данный момент Вы платите только за товар.',
    value:
      'In order to provide the best import quotation, the exact shipping and other cost quotation is calculated once the product arrives at our warehouse, so now you only pay for the product.',
  },
  {
    key: '由于货物的分组和其他数据，我们可以提供一个更好的最终报价的运输。',
    value:
      'Благодаря группировке товаров и другим данным мы можем предоставить более выгодное окончательное ценовое предложение на услуги перевозки.',
  },
  {
    key:
      '这一细分包括产品的质量控制、合同规定的额外服务，以及在适当情况下合同规定的其他费用。',
    value:
      'Этот сегмент включает в себя контроль качества продукции, дополнительные услуги, предусмотренные договором, и предусмотренные другие договором расходы, в ситуациях, где это уместно.',
  },
  {
    key: '选择运输类型以获得最终的运输报价',
    value: 'Пожалуйста, выберите способ доставки（предсказать）',
  },
  {
    key: '推荐',
    value: 'Рекомендации',
  },
  {
    key: '已了解',
    value: 'Ясно',
  },
  {
    key: '已理解',
    value: 'Ясно',
  },
  {
    key: '订单细节确认',
    value: 'Подтвердить детали заказа',
  },
  {
    key: '谢谢你。您的订单细节已正确确认。',
    value: 'Спасибо Вам. Данные Вашего заказа были корректно подтверждены.',
  },
  {
    key: '邮箱',
    value: 'Электронная почта',
  },
  {
    key:
      '在24小时之内，您将收到一封电子邮件，里边包含该订单的国际运输方式和预估运输费用。',
    value:
      'В течение 24 часов вы получите письмо на электронную почту с указанием  способа международной доставки заказа и ориентировочной стоимости доставки.',
  },
  {
    key:
      '为了提供一个估计的运输报价，我们必须知道产品的尺寸和确切的重量。这就是为什么我们联系制造商，并计算您的订单的估计运输成本。',
    value:
      'Чтобы предоставить приблизительный расчет стоимости услуг по перевозке, мы должны знать размер и точный вес товара. Именно поэтому мы связываемся с производителем и рассчитываем ориентировочную стоимость услуг перевозки  Вашего заказа.',
  },
  {
    key: '订单摘要',
    value: 'Краткое описание заказа',
  },
  {
    key: '购买金额',
    value: 'Сумма покупки',
  },
  {
    key: '后续怎么操作',
    value: 'Как действовать в дальнейшем',
  },
  {
    key: '如何运作',
    value: 'Как это работает',
  },
  {
    key: '我们联系制造商',
    value: 'Мы свяжемся с производителем',
  },
  {
    key: '委员会',
    value: 'Комитет',
  },
  {
    key:
      '我们联系制造商确认产品购买费用，箱规尺寸等必要信息，从而预估产品的运输成本。',
    value:
      'Мы связываемся с производителем, чтобы подтвердить необходимую информацию, такую как стоимость прибретения товара, размер упаковки и т.д., чтобы оценить стоимость транспортировки товара.',
  },
  {
    key: '您会在24小时内收到报价',
    value: 'Вы получите ценовое предложение в течение 24 часов',
  },
  {
    key: '这份报价中包括所有类型的预估国际运费（空运、海运和陆运）。',
    value:
      'Это ценовое предложение включает все виды предполагаемых международных перевозок (воздушные, морские и наземные).',
  },
  {
    key: '产品的付款',
    value: 'Оплата за товар',
  },
  {
    key:
      'После того, как мы вышлем Вам ориентировочную стоимость международной перевозки, Вы сможете официально приобрести товар по Вашему заказу.',
    value:
      'Once you have reviewed and confirmed the estimated shipping costs, you can proceed with placing an order for the product.',
  },
  {
    key: '为什么现在估计装运费用?',
    value:
      'Почему ориентировочная стоимость преревозки рассчитана именно сейчас?',
  },
  {
    key: '你有什么问题吗?',
    value: 'У Вас имеются какие-либо вопросы?',
  },
  {
    key: '使用RAKU-chat与我们沟通',
    value: 'Используйте RAKU-чат для связи с нами',
  },
  {
    key: '使用WhatsApp与我们沟通',
    value: 'Используйте WhatsApp для связи с нами',
  },
  {
    key: '银行转帐',
    value: 'Банковский перевод',
  },
  {
    key: '把你的订单转到我们的银行账户。',
    value: 'Переведите сумму Вашего заказа на наш банковский счет',
  },
  {
    key: '订单正在处理中',
    value: 'Заказ находится в стадии обработки',
  },
  {
    key: '请允许1至2个工作日处理订单。',
    value: 'Ожидается, что заказ будет обработан в течение 1-2 рабочих дней.',
  },
  {
    key: '我们进行购买',
    value: 'Приступить к покупкам',
  },
  {
    key: '我们购买您的产品并将其送到我们的仓库。',
    value: 'Приобретенные товары будут доставлены на наш склад.',
  },
  {
    key: '产品费用支付',
    value: 'Оплата расходов за товар',
  },
  {
    key: 'Envio仓库',
    value: 'Склад',
  },
  {
    key: '进口商联系人',
    value: 'Контактное лицо импора',
  },
  {
    key: '付款方式',
    value: 'Способ оплаты',
  },
  {
    key: '信用卡',
    value: 'Кредитная карта',
  },
  {
    key: '接收银行信息',
    value: 'Получать банковскую информацию',
  },
  {
    key:
      '使用以下银行信息通过您的网上银行或移动应用程序进行转账。一旦订单被处理，就会进行购买。',
    value:
      'Используйте следующую банковскую информацию для осуществления денежного перевода через Ваш онлайн-банкинг или мобильное приложение. Как только заказ будет принят, покупка будет совершена.',
  },
  {
    key: '使用订单号作为付款概念/参考:',
    value:
      'Используйте номер заказа в качестве основания для оплаты/ссылки на оплату:',
  },
  {
    key: '收件人名称',
    value: 'Имя получателя',
  },
  {
    key: 'SWIFT帐户',
    value: 'Номер счета',
  },
  {
    key: '银行名称',
    value: 'Наименование банка',
  },
  {
    key: '进行付款',
    value: 'Произвести оплату',
  },
  {
    key: 'Redsys CaixaBank支付网关',
    value: 'Банковский платежный шлюз',
  },
  {
    key: '我已了解并同意该网站的隐私政策条',
    value:
      'Я ознакомлен и согласен с политикой конфиденциальности данного веб-сайта',
  },
  {
    key: '我知道并同意本网站的',
    value: 'Я ознакомлен и согласен',
  },
  {
    key: '隐私政策条款和条件',
    value:
      'с положениями и условиями политики конфиденциальности данного веб-сайта',
  },
  {
    key: '订单支付完成',
    value: 'Оплата заказа завершена',
  },
  {
    key: '控制面板',
    value: 'Панель управления',
  },
  {
    key: '修改数据',
    value: 'Изменить данные',
  },
  {
    key: '接下来是什么?',
    value: 'Что дальше?',
  },
  {
    key: '我们从工厂接收你们的产品',
    value: 'Мы получаем Ваш товар с завода',
  },
  {
    key: '购买您的产品的过程已经开始。',
    value: 'Процесс покупки Вашего товара начался',
  },
  {
    key: '我们期待在我们的仓库收到你们的产品。',
    value: 'Мы с нетерпением ждем получения Вашего товара на нашем складе',
  },
  {
    key: '质量控制和处理',
    value: 'Контроль качества и обработка',
  },
  {
    key:
      '检品人员在收到货物后会进行货物的质量检测并完成您的附加服务（如果您的订单有选择附加服务）',
    value:
      'После получения товара специалист контроля качества проведет проверку качества товара и выполнит выбранные Вами дополнительные услуги (если Вы выберете дополнительные услуги для своего заказа).',
  },
  {
    key: '运费和运输报价',
    value: 'Ценовое предложение по стоимости услуг перевозки и доставке',
  },
  {
    key:
      '我们将会选择最合理的国际运输方式，并为您报价，在5-7天内装运完成您的货物',
    value:
      'Мы выберем наиболее оптимальный способ международной перевозки, предложим Вам цену и отправим Ваш товар в течение 5-7 дней',
  },
  {
    key: '运费支付',
    value: 'Оплата стоимости услуг по перевозке',
  },

  {
    key: '修改收货地址',
    value: 'Изменить адрес доставки',
  },
  {
    key: '城市',
    value: 'Город',
  },
  {
    key: '公司(可选)',
    value: 'Компания (необязательно для заполнения)',
  },
  {
    key: '国际运输的最终报价',
    value:
      'Окончательное ценовое предложение по стоимости международной перевозки',
  },
  {
    key: '进口总成本细目(包括物流和税收)',
    value:
      'Подробная информация об общей стоимости услуг по импорту (включая логистику и налоги)',
  },
  {
    key: '国际运输',
    value: 'Международные перевозки',
  },
  {
    key: '应付总额',
    value: 'Общая сумма к оплате',
  },
  {
    key: '国际航运付款',
    value: 'Оплата международной перевозки морем',
  },
  {
    key: '进口',
    value: 'Импорт',
  },
  {
    key: '请联系客服修改配送单地址',
    value:
      'Пожалуйста, обратитесь в службу поддержки клиентов, чтобы изменить адрес в сопроводительном документе',
  },
  {
    key: '替换商品',
    value: 'Заменить товар',
  },
  {
    key: '库存不足商品',
    value: 'Недостачно товара на складе',
  },
  {
    key: 'Raku消息',
    value: 'Сообщения от Raku',
  },
  {
    key: '库存数量不足',
    value: 'Количества, имеющегося на складе недостаточно',
  },
  {
    key: '可选择替换的商品',
    value: 'Товары, которые можно заменить',
  },
  {
    key: 'Sponlax帮助您从中国进口货物',
    value: 'Sponlax поможет Вам импортировать товары из Китая',
  },
  {
    key:
      'Sponlax让您轻松获得从中国进口的"一站式"服务，包括工厂采购、质量检验、附加服务和国际航运。',
    value:
      'Sponlax позволит Вам легко получить целый комплекс услуг по импорту из Китая, включая закупки с завода-изготовителя, проверку качества, дополнительные услуги и международную доставку.',
  },
  {
    key: '全面、便捷的中国进口管理。',
    value: 'Комплексное и удобное управление импортом из Китая',
  },
  {
    key: '待报价订单',
    value: 'Заказы, ожидающие установку ценового предложения',
  },
  {
    key: '以您为中心',
    value: 'Ориентированность на клиентов',
  },
  {
    key: '我们为您购买产品并优化所有的物流成本',
    value:
      'Мы закупаем товары для Вас и оптимизируем все логистические расходы',
  },
  {
    key: '完整的物流服务',
    value: 'Комплексные логистические услуги',
  },
  {
    key: '后勤服务',
    value: 'Услуги по логистике',
  },
  {
    key: '公平和有价值的佣金为您的业务',
    value: 'Экономически выгодный тариф на комиссию за обслуживание',
  },
  {
    key: '消费越多，等级越高，佣金越少',
    value:
      'Чем больше Вы тратите, тем выше уровень и тем меньше комиссионный сбор за обслуживание',
  },
  {
    key: '佣金说明',
    value: 'Описание платы за обслуживание',
  },
  {
    key: '为所有的产品提供附加服务',
    value: 'Предоставление дополнительных услуг для всех товаров',
  },
  {
    key: '其他服务和完整解决方案',
    value: 'Другие услуги и комплексные решения',
  },
  {
    key: '购买中',
    value: 'В процессе совершения покупки',
  },
  {
    key: '请至少选择一项物流方式',
    value: 'Пожалуйста, выберите хотя бы один способ логистики',
  },
  {
    key: '国际费用明细',
    value: 'Подробная информация о международных расходах',
  },
  {
    key: '特价商品',
    value: 'Товары, на которые действуют специальные предложения',
  },
  {
    key: '请将您的个人信息填入下方，所有字段都是必填字段。',
    value:
      'Пожалуйста, заполните Ваши персональные данные ниже, все поля обязательны для заполнения.',
  },
  {
    key: '操作',
    value: 'Операция',
  },
  {
    key: '临时保存',
    value: 'Временное сохранение',
  },
  {
    key: '追加',
    value: 'Добавить',
  },
  {
    key: '入金确认中',
    value: 'Подтверждение депозита в процессе',
  },
  {
    key:
      '*由于供应商活动取消等原因，商品实际的价格和Sponlax平台展现的价格可能会有出入。我们将在订单报价时将最终确认的价格提交给您。',
    value:
      '*По таким причинам, как отмена акционного предложения у поставщика, фактическая цена товара может отличаться от цены, отображаемой на платформе Sponlax. Мы отправим Вам окончательную подтвержденную цену, когда выставим ценовое предложение на заказ.',
  },
  {
    key: '搜索图片:',
    value: 'Поиск товаров с картинками:',
  },
  {
    key: '竖版',
    value: 'Вертикальная версия',
  },
  {
    key: '横版',
    value: 'Горизонтальная версия',
  },
  {
    key: '电子邮箱认证',
    value: 'Сертификат по электронной почте',
  },
  {
    key: '今日人民币与卢布兑换汇率',
    value: 'Сегодняшний обменный курс между юанем и рублем',
  },
  {
    key: '附加服务费用',
    value: 'Плата за дополнительные услуги',
  },
  {
    key: '用户电子邮件',
    value: 'Электронная почта пользователя',
  },

  {
    key: '很高兴你能来',
    value: 'Мы рады, что Вы пришли',
  },
  {
    key: '发送时间',
    value: 'Мы рады, что Вы пришли',
  },
  {
    key: '谢谢，你的订单号',
    value: 'Благодарим Вас, номер Вашего заказа',
  },
  {
    key: '谢谢。 关于您的订单号',
    value: 'Благодарим Вас. О номере Вашего заказа',
  },
  {
    key: '分区',
    value: 'Раздел',
  },
  {
    key: '21+',
    value: '21кг+',
  },
  {
    key: '71+',
    value: '71кг+',
  },
  {
    key: '100+',
    value: '100кг+',
  },
  {
    key: '美西8.9',
    value: 'The Western United States 8.9',
  },
  {
    key: '32',
    value: '￥32',
  },
  {
    key: '31',
    value: '￥31',
  },
  {
    key: '29',
    value: '￥29',
  },
  {
    key: '美中4.5.6.7',
    value: 'The Central United States 4.5.6.7',
  },
  {
    key: '33',
    value: '￥33',
  },
  {
    key: '32',
    value: '￥32',
  },
  {
    key: '30',
    value: '￥30',
  },
  {
    key: '美东0.1.2.3',
    value: 'The Eastern United States 0.1.2.3',
  },
  {
    key: '34',
    value: '￥34',
  },
  {
    key: '33',
    value: '￥33',
  },
  {
    key: '31',
    value: '￥31',
  },
  {
    key: '时效',
    value: 'Delivery time',
  },
  {
    key: '9-14天到客户手上',
    value: '9-14 days',
  },
  {
    key: '25-30天到客户手上',
    value: '25-30 days',
  },
  {
    key: '俄罗斯国内派送方式',
    value: 'US domestic delivery method',
  },
  {
    key: 'UPS派送',
    value: 'Доставка UPS',
  },
  {
    key: '非亚马逊地址，整票计费价格+1元/KG	',
    value: 'Адрес не на Amazon, полная стоимость билета +1 юань/КГ',
  },
  {
    key: '包裹重量要求',
    value: 'Требования к весу упаковки',
  },
  {
    key: '单箱计费重少于12KG的,按照12KG算,单箱实重大于等于22.5KG加收170元/件。',
    value:
      'Если расчетный вес одной коробки составляет менее 12 кг, то, согласно расчету в 12 кг, если фактический вес одной коробки больше или равен 22,5 кг, то взимается дополнительная плата в размере 170 юаней за штуку.',
  },
  {
    key:
      '单件包裹任何一边长超过120CM，收取超长费用120CNY/件，第二边超过75CM，同样收取120CNY/件,',
    value:
      'За упаковку посылки длиной более 120 см с каждой стороны взимается дополнительная плата в размере 120 юаней за штуку, а также 120 юаней за штуку за вторую сторону, длина которой превышает 75 см.,',
  },
  {
    key: '单边超150CM，不能发',
    value:
      'Имеет длину более 150 см с одной стороны и не может быть отправлено',
  },
  {
    key: '单件包裹长+（宽+高）*2，如果超过266CM收取超长费用120CNY/件',
    value:
      'Длина упаковки + (ширина +высота)*2, если она превышает 266 см, взимается дополнительная плата в размере 120 юаней за штуку.',
  },
  {
    key: '如果超过330CM，不能发',
    value: 'Если превышает 330 см, то товар не может быть отправлен',
  },
  {
    key: '单件包裹实重大于40KG，不能发',
    value:
      'Одна посылка на самом деле тяжелее 40 кг, то она не может быть отправлена',
  },
  {
    key: '附加费',
    value: 'Доплата',
  },
  {
    key: '包包，服装，鞋类、汽车配件、摩托车配件，整票计费价格+1元/KG',
    value:
      'Сумки, одежда, обувь, автозапчасти, запчасти для мотоциклов, полная стоимость билета +1 юань/кг',
  },
  {
    key: '餐具需提供FDA证书，整票计费价格+1/KG',
    value:
      'Посуда должна иметь сертификат FDA, полная стоимость билета +1 юань/кг',
  },
  {
    key: '眼镜，整票计费价格+2/KG',
    value: 'Очки, полная стоимость билета +2/КГ',
  },
  {
    key: '手表附加费+5/支',
    value: 'Доплата за часы +5/штука',
  },
  {
    key: '每票默认5个品名，每多加1个品名，加收30元',
    value:
      'По умолчанию в каждом билете указано 5 наименований товаров, и за каждое дополнительное наименование товара взимается дополнительная плата в размере 30 юаней.',
  },
  {
    key: '偏远地区收费标准',
    value: 'Стандарты взимания платы для отдаленных районов',
  },
  {
    key: '偏远地址20元/箱，超偏远地址30元/箱',
    value:
      'Удаленный адрес 20 юаней/коробка, супер-удаленный адрес 30 юаней/коробка',
  },
  {
    key: '限制发送商品',
    value: 'Ограничить отправку товаров',
  },
  {
    key:
      '不接仿牌、纯电池、贵金属、化工品、敏感品、儿童玩具类、违禁品、易燃易爆等明确规定的商品',
    value:
      'Не принимаются поддельные бренды, цельные батарейки, драгоценные металлы, химикаты, чувствительные товары, детские игрушки, запрещенные товары, легковоспламеняющиеся и взрывоопасные изделия и другие четко определенные виды товаров.',
  },
  {
    key: '预计进口产品费用明细',
    value:
      'Подробная информация о предполагаемой стоимости импортируемых товаров',
  },
  {
    key: '容积约为',
    value: 'Объем составляет около(m ³）',
  },
  {
    key: '立方米',
    value: 'Кубический метр',
  },
  {
    key: '产品费用',
    value: 'Стоимость товара',
  },
  {
    key: '附加服务',
    value: 'Дополнительные услуги',
  },
  {
    key: '中国物流费用',
    value: 'Плата за логистические услуги на территории Китая',
  },
  {
    key: '不含运费的产品总成本',
    value: 'Общая стоимость товара без учета  расходов на перевозку',
  },
  {
    key: '特拉华州',
    value: '',
  },
  {
    key: '产品成本',
    value: 'Стоимость товара',
  },
  {
    key: '预估国际运费',
    value: 'Предполагаемая стоимость расходов на международную перевозку',
  },
  {
    key: '预估俄罗斯国内运费',
    value: 'Предполагаемая стоимость внутренних перевозок по России',
  },
  {
    key: '包含运费产品总成本 ',
    value: 'Включая расходы на перевозку, общая стоимость товара',
  },
  {
    key:
      '已生成正确，并且已经在发送到我们仓库的过程中。 我们已经向您发送了一封包含详细信息的电子邮件。请按照个人中心中的状态进行操作。',
    value:
      'Сгенерирован правильно и уже находится в процессе отправки на наш склад. Мы отправили Вам письмо на электронную почту с подробной информацией. Пожалуйста, следите за статусом в личном кабинете.',
  },
  {
    key:
      '的发送：您已正确付款并且您的货物已在发送至我们在巴塞罗那的仓库。 商品到货时将提供国家快递（GLS）的追踪号码。您可以在个人中心中查看状态。',
    value:
      'Отправка: вы правильно произвели оплату, и Ваш товар уже отправлен на наш склад в Барселоне. Номер для отслеживания National Express (GLS) будет предоставлен, когда прибудет товар. Вы можете проверить статус заказа в личном кабинете.',
  },
  {
    key: '成为rakumart的一员',
    value: 'Стать членом rakumart',
  },
  {
    key: '现在注册',
    value: 'Зарегистрируйтесь сейчас',
  },
  {
    key: '搜索并下单您感兴趣的产品',
    value: 'Найдите и оформите заказ на интересующий Вас товар',
  },
  {
    key: '中国仓库将存储并为您检查货物',
    value:
      'Китайский склад（CAWD） будет хранить и проверять качество товаров для Вас',
  },
  {
    key: '预估总费用',
    value: 'Предполагаемая общая стоимость',
  },
  {
    key: '您需要支付国际运输的费用',
    value:
      'Вам необходимо оплатить стоимость расходов на международную перевозку',
  },
  {
    key: '特色类别',
    value: 'Особенная категория',
  },
  {
    key: '费用相关',
    value: 'О стоимости',
  },
  {
    key: '俄罗斯运输中的订单',
    value: 'Заказы в пути по России',
  },
  {
    key: '购买完了',
    value: 'Покупка завершена',
  },
  {
    key: '没有调整',
    value: 'Без корректировок',
  },
  {
    key: '实际购买数量',
    value: 'Фактически приобретенное количество',
  },
  {
    key: '提现',
    value: 'Вывод средств',
  },
  {
    key: '包含运费产品总成本  ',
    value: 'Включая расходы на перевозку, общая стоимость товара',
  },
  {
    key: '请在',
    value: 'Пожалуйста',
  },
  {
    key: '电子邮箱验证',
    value: 'Получите проверочный код на электронную почту',
  },
  {
    key: '手机号码验证',
    value: 'Получите проверочный код на номер мобильного телефона',
  },
  {
    key: '秒后重新获取验证码',
    value: 'Получите проверочный код повторно через секунду',
  },
  {
    key: '订单取消日期',
    value: 'Дата отмены заказа',
  },
  {
    key: '修改',
    value: 'Исправить',
  },
  {
    key: '配送单详情',
    value: 'Упаковочный лист',
  },
  {
    key: '计费重量',
    value: 'Расчетный вес',
  },
  {
    key: '已完成',
    value: 'Завершено',
  },
  {
    key: '订单完成',
    value: 'Заказ завершен',
  },
  {
    key: '服务条款',
    value: 'Условия предоставления услуг',
  },
  {
    key: '隐私政策',
    value: 'Политика конфиденциальности',
  },
  {
    key:
      '我们将会选择最合理的国际运输方式，并为您报价，在5-7天内装运完成您的货物-7天内装运你的货物。',
    value:
      'Мы выберем наиболее отимальный способ международной перевозки, предложим Вам цену и отправим Ваш товар в течение 5-7 дней',
  },
  {
    key: '国际航运的最终报价',
    value:
      'Окончательное ценовое предложение по стоимости международной перевозки',
  },
  {
    key: '应付款金额',
    value: 'Сумма, подлежащая оплате',
  },
  {
    key: '付款后余额',
    value: 'Баланс счета после оплаты',
  },
  {
    key: '去支付',
    value: 'Перейти к оплате',
  },
  {
    key: '在线支付',
    value: 'Совершить оплату онлайн',
  },
  {
    key: '返回',
    value: 'Возврат',
  },
  {
    key: '电子邮件/手机号码',
    value: 'Адрес электронной почты/номер мобильного телефона',
  },
  {
    key: '未查找到该账号，请核对后再尝试或联系客服处理',
    value:
      'Номер аккаунта не был найден, пожалуйста, проверьте правильность ввода данных и попробуйте еще раз или обратитесь в службу поддержки клиентов ',
  },
  {
    key: '谢谢，关于您的订单号',
    value: 'Благодарим Вас. О номере Вашего заказа',
  },
  {
    key: '随着你的购买量的增加，你必须支付的佣金率将逐渐降低。',
    value:
      'По мере увеличения количества совершенных Вашими покупок, величина комиссионного сбора за обслуживание, который Вам придется оплачивать, будет постепенно снижаться.',
  },
  {
    key: '我们将根据订单中货物的价值收取佣金。',
    value:
      'Мы будем взимать комиссию, в зависимости от стоимости товара в заказе.',
  },
  {
    key: '佣金率是根据您购买的商品的累计价值确定的。（货物价值=数量*单价）',
    value:
      'Стоимость комиссии за оказываемые услуги определяется исходя из совокупной стоимости приобретенных Вами товаров.(Стоимость товара = количество товара * цена за единицу)',
  },
  {
    key:
      '例如，如果您购买的商品的累计价值超过1000000卢布，您未来订单的佣金将变为9%。',
    value:
      'Например, если совокупная стоимость приобретенных Вами товаров превысит 1,000,000 Рубль, комиссия за Ваши будущие заказы составит 9%.',
  },
  {
    key: '请参阅下表，查看您购买商品的累计价值所对应的百分比：',
    value:
      'Пожалуйста, обратитесь к таблице ниже, чтобы увидеть процент, соответствующий совокупной стоимости приобретенных Вами товаров:',
  },
  {
    key: '谢谢，关于您的配送单号',
    value:
      'Благодарим Вас, о номере Вашего сопроводительного документа на заказ',
  },
  {
    key: '收件地址',
    value: 'Адрес получения товара',
  },
  {
    key: '配送单费用支付',
    value: 'Оплата стоимости, указанной в сопроводительном документе',
  },
  {
    key: '请输入旧登录密码',
    value: 'Пожалуйста, введите старый пароль для входа в систему',
  },
  {
    key: '您可以查询订单进程，最后货物送达到你的手中',
    value:
      'Вы можете проверить процесс оформления заказа, и, наконец, товар будет доставлен Вам',
  },
  {
    key: '可用余额',
    value: 'Доступный баланс',
  },
  {
    key: 'paypal付款的情况下，还需要5%的手续费，请事先谅解',
    value:
      'В случае оплаты через PayPal взимается комиссия за обработку в размере 5%, пожалуйста, примите это к сведению заранее',
  },
  {
    key: '是否使用PayPal支付？',
    value: 'Использовать PayPal для оплаты?',
  },
  {
    key: '请输入充值金额，使其超过估价总额',
    value:
      'Пожалуйста, введите сумму пополнения таким образом, чтобы она превышала предварительную общую стоимость',
  },
  {
    key: '支付失败',
    value: 'Оплата не произведена',
  },
  {
    key: '对于给您带来的不便，我们深表歉意，但请重新操作。',
    value:
      'Мы приносим извинения за причиненные Вам неудобства, однако просим произвести операцию еще раз.',
  },
  {
    key: '手续费',
    value: 'Комиссионный сбор',
  },
  {
    key: '阿迪格共和国',
    value: 'Республика Адыгея',
  },
  {
    key: '阿尔泰共和国',
    value: 'Республика Алтай',
  },
  {
    key: '巴什科尔托斯坦共和国',
    value: 'Республика Башкортостан',
  },
  {
    key: '所有待处理的订单',
    value: 'Приказ, с которым нужно разобраться',
  },
  {
    key: '检品',
    value: 'Прокурор',
  },
  {
    key: '待装仓',
    value: 'Склад.',
  },
  {
    key: '上架完了订单数',
    value: 'Мы закончили с заказами',
  },
  {
    key: '手续费比例',
    value: 'Процент комиссионных',
  },
  {
    key: '手续费是如何计算的？',
    value: 'Как расчитаны комиссионные？',
  },
  {
    key: '我们将预估国际费用发送给您后，您就可以正式购买您的订单的产品了。',
    value:
      'Чтобы обеспечить наилучшее импортное предложение, как только товар будет доставлен на наш склад, будут расчитаны точные расходы на доставку и другие расходы, так что теперь вы платите только за товар.',
  },
  {
    key:
      '为了提供最好的进口报价，一旦产品到达我们的仓库，就会计算出准确的运费和其他费用报价，所以现在你只支付产品。',
    value:
      'После того, как мы пришлем вам прогноз международных расходов, вы сможете официально купить продукцию, которую заказываете.',
  },
  {
    key: '布里亚特共和国',
    value: 'Республика Бурятия',
  },
  {
    key: '达吉斯坦共和国',
    value: 'Республика Дагестан',
  },
  {
    key: '印古什共和国',
    value: 'Республика Ингушетия',
  },
  {
    key: '卡巴尔达–巴尔卡尔共和国',
    value: 'Кабарди́но-Балка́рия',
  },
  {
    key: '卡尔梅克共和国',
    value: 'Республика Калмыкия',
  },
  {
    key: '卡拉恰伊-切尔克斯共和国',
    value: 'Карачаево-Черкесская Республика',
  },
  {
    key: '卡累利阿共和国',
    value: 'Республика Карелия',
  },
  {
    key: '科米共和国',
    value: 'Республика Коми',
  },
  {
    key: '马里埃尔共和国',
    value: 'Республика Марий Эл',
  },
  {
    key: '萨哈（雅库特）共和国',
    value: 'Республика Саха（Якутия）',
  },
  {
    key: '北奥塞梯-阿兰共和国',
    value: 'Республика Северная Осетия-Алания',
  },
  {
    key: '鞑靼斯坦共和国',
    value: 'Республика Татарстан',
  },
  {
    key: '图瓦共和国',
    value: 'Респу́блика Тыва́',
  },
  {
    key: '乌德穆尔特共和国',
    value: 'Удмуртская республика',
  },
  {
    key: '哈卡斯共和国',
    value: 'Республика Хакасия',
  },
  {
    key: '车臣共和国',
    value: 'Чеченская Республика',
  },
  {
    key: '楚瓦什自治共和国',
    value: 'Чувашская Республика',
  },
  {
    key: '莫尔多瓦共和国',
    value: 'Республика Мордовия',
  },
  {
    key: '克里米亚共和国',
    value: 'Крым',
  },
  {
    key: '阿尔泰边疆区',
    value: 'Алтайский край',
  },
  {
    key: '克拉斯诺达尔边疆区',
    value: 'Краснодарский край',
  },
  {
    key: '克拉斯诺亚尔斯克边疆区',
    value: 'Красноярский край',
  },
  {
    key: '滨海边疆区',
    value: 'Приморский край',
  },
  {
    key: '斯塔夫罗波尔边疆区',
    value: 'Ставропольский край',
  },
  {
    key: '哈巴罗夫斯克边疆区',
    value: 'Хабаровский край',
  },
  {
    key: '堪察加边疆区',
    value: 'Камчатский край',
  },
  {
    key: '彼尔姆边疆区',
    value: 'Пермский край',
  },
  {
    key: '后贝加尔边疆区',
    value: 'Забайкальский край',
  },
  {
    key: '阿穆尔州',
    value: 'Амурская область',
  },
  {
    key: '阿尔汉格尔斯克州',
    value: 'Архангельская область',
  },
  {
    key: '阿斯特拉罕州',
    value: 'Астраханская область',
  },
  {
    key: '别尔哥罗德州',
    value: 'Белгородская область',
  },
  {
    key: '布良斯克州',
    value: 'Брянская область',
  },
  {
    key: '弗拉基米尔州',
    value: 'Владимирская область',
  },
  {
    key: '伏尔加格勒州',
    value: 'Волгоградская область',
  },
  {
    key: '沃洛格达州',
    value: 'Вологодская область',
  },
  {
    key: '沃罗涅日州',
    value: 'Воронежская область',
  },
  {
    key: '伊万诺沃州',
    value: 'Ивановская область',
  },
  {
    key: '伊尔库茨克州',
    value: 'Иркутская область',
  },
  {
    key: '加里宁格勒州',
    value: 'Калининградская область',
  },
  {
    key: '卡卢加州',
    value: 'Калу́жская о́бласть',
  },
  {
    key: '克麦罗沃州',
    value: 'Кемеровская область',
  },
  {
    key: '基洛夫州',
    value: 'Кировская область',
  },
  {
    key: '科斯特罗马州',
    value: 'Костромская область',
  },
  {
    key: '库尔干州',
    value: 'Курганская область',
  },
  {
    key: '库尔斯克州',
    value: 'Курская область',
  },
  {
    key: '列宁格勒州',
    value: 'Ленинградская область',
  },
  {
    key: '利佩茨克州',
    value: 'Липецкая область',
  },
  {
    key: '利佩茨克州',
    value: 'Липецкая область',
  },
  {
    key: '马加丹州',
    value: 'Магаданская область',
  },
  {
    key: '莫斯科州',
    value: 'Московская область',
  },
  {
    key: '摩尔曼斯克州',
    value: 'Мурманская область',
  },
  {
    key: '下诺夫哥罗德州',
    value: 'Нижегородская область',
  },
  {
    key: '诺夫哥罗德州',
    value: 'Новгородская область',
  },
  {
    key: '新西伯利亚州',
    value: 'Новосибирская область',
  },
  {
    key: '鄂木斯克州',
    value: 'Омская область',
  },
  {
    key: '奥伦堡州',
    value: 'Оренбургская область',
  },
  {
    key: '奥廖尔州',
    value: 'Орловская область',
  },
  {
    key: '奔萨州',
    value: 'Пензенская область',
  },
  {
    key: '普斯科夫州',
    value: 'Псковская область',
  },
  {
    key: '罗斯托夫州',
    value: 'Ростовская область',
  },
  {
    key: '梁赞州',
    value: 'Рязанская область',
  },
  {
    key: '萨马拉州',
    value: 'Сама́рская о́бласть',
  },
  {
    key: '托木斯克州',
    value: 'Томская область',
  },
  {
    key: '萨拉托夫州',
    value: 'Саратовская область',
  },
  {
    key: '萨哈林州',
    value: 'Сахали́нская о́бласть',
  },
  {
    key: '斯维尔德洛夫斯克州',
    value: 'Свердловская область',
  },
  {
    key: '斯摩棱斯克州',
    value: 'Смоленская область',
  },
  {
    key: '坦波夫州',
    value: 'Тамбовская область',
  },
  {
    key: '特维尔州',
    value: 'Тверская область',
  },
  {
    key: '图拉州',
    value: 'Тульская область',
  },
  {
    key: '秋明州',
    value: 'Тюменская область',
  },
  {
    key: '乌里扬诺夫斯克州',
    value: 'Улья́новская о́бласть',
  },
  {
    key: '车里雅宾斯克州',
    value: 'Челя́бинская о́бласть',
  },
  {
    key: '雅罗斯拉夫尔州',
    value: 'Ярославская область',
  },
  {
    key: '莫斯科',
    value: 'Москва',
  },
  {
    key: '圣彼得堡',
    value: 'Санкт-Петербург',
  },
  {
    key: '塞瓦斯托波尔',
    value: 'Севастополь',
  },
  {
    key: '犹太自治州',
    value: 'Евре́йская автоно́мная о́бласть',
  },
  {
    key: '涅涅茨自治区',
    value: 'Нене́цкий автоно́мный о́круг',
  },
  {
    key: '汉特曼西斯克民族自治区',
    value: 'Ханты-Мансийский автономный округ',
  },
  {
    key: '楚科奇民族自治区',
    value: 'Чукотский автономный округ',
  },
  {
    key: '亚马尔-涅涅茨自治区',
    value: 'Ямало-Ненецкий автономный округ',
  },
  {
    key: '成为Sponlax的一员',
    value: 'Стать частью Sponlax',
  },
  {
    key: '订单进程',
    value: 'Порядок.',
  },
  {
    key: '问题商品明细',
    value: 'Детали проблемных продуктов.',
  },
  {
    key: '付款后，您的货物将被存放在Sponlax中国仓库。',
    value: 'После оплаты ваш товар будет храниться на складе Sponlax в Китае.',
  },
  {
    key: '源链接',
    value: 'Исходные ссылки',
  },
  {
    key: '综合点评',
    value: 'Общий отзыв',
  },
  {
    key: '品质点评',
    value: 'Отзыв о качестве',
  },
  {
    key: '物流点评',
    value: 'Отзыв о логистике',
  },
  {
    key: '问题解决',
    value: 'Решение проблемы',
  },
  {
    key: '咨询',
    value: 'Консультация',
  },
  {
    key: '同店铺商品',
    value: 'Товары из того же магазина',
  },
  {
    key: '类似商品',
    value: 'Похожие товары',
  },
  {
    key: '意见反馈',
    value: 'Обратная связь',
  },
  {
    key: '新:我们刚刚发布了谷歌Chrome的扩展',
    value: 'Мы только что выпустили расширение для Google Chrome',
  },
  {
    key: '安装Chrome扩展',
    value: 'Установить расширение Chrome',
  },
  {
    key: '用手机扫描二维码开始聊天',
    value: 'Отсканируйте QR-код на своем телефоне, чтобы начать чат',
  },
  {
    key: '发起聊天',
    value: 'Начать чат',
  },
  //--------------dnk--------------
  {
    key: '综合排序',
    value: 'Комплексная сортировка',
  },
  {
    key: '月贩卖数',
    value: 'Месячный объем продаж',
  },
  {
    key: '复购率',
    value: 'Повторные покупки',
  },
  {
    key: '最低价',
    value: 'Минимальная цена',
  },
  {
    key: '最高价',
    value: 'Максимальная цена',
  },
  {
    key: '商品名搜索',
    value: 'Поиск по названию товара',
  },
  {
    key: '最低价不能大于或等于最高价',
    value: 'Минимальная цена не может быть больше или равна максимальной цене',
  },
  {
    key: '请输入大于等于0的数字',
    value: 'Пожалуйста, введите число больше или равное 0',
  },
  //--------------dnk--------------
  {
    key: '下单数量',
    value: 'Количество',
  },
  {
    key: '实际采购数量',
    value: 'Доступно у поставщика',
  },
  {
    key: '小计',
    value: 'Итого',
  },
  {
    key: '产品价值',
    value: 'Стоимость продукта',
  },
  {
    key: '产品总支出',
    value: 'Общие расходы на продукт',
  },
  {
    key: '商品名',
    value: 'Название товара',
  },
  {
    key: '规格',
    value: 'Спецификация',
  },
  {
    key: '调查数量',
    value: ' Количество',
  },
  {
    key: '预估进口详情',
    value: 'Оценочные данные по импорту',
  },
  {
    key: '详细',
    value: 'подробный',
  },
  {
    key: '价格明细',
    value: 'Расчёт стоимости【DDP】',
  },
  {
    key: '支付时间',
    value: 'Время оплаты',
  },
  {
    key: '物流详情',
    value: 'Детали логистики',
  },
  {
    key: '费用',
    value: 'Затраты',
  },
  {
    key: '请选择要回复的商品',
    value: 'Пожалуйста, выберите товар для ответа',
  },
  {
    key: '您可以在这里添加产品备注',
    value: 'Вы можете добавить примечание к продукту здесь',
  },
  {
    key: '删除地址',
    value: 'Удалить адрес',
  },
  {
    key: '详细地址',
    value: 'Подробный адрес',
  },

  {
    key: '图片搜索',
    value: 'Поиск по изображению',
  },
  {
    key: '所有分类',
    value: 'Каталог',
  },
  {
    key: '严选',
    value: 'Строгий отбор',
  },
  {
    key: '1688精选商品',
    value: 'Товары, отобранные на 1688',
  },
  {
    key: '1688精选工厂',
    value: 'Отобранная фабрика на платформе 1688',
  },
  {
    key: '优势',
    value: 'Преимущества',
  },
  {
    key: '当日出货',
    value: 'Отправка в тот же день',
  },
  {
    key: '24小时以内出货',
    value: 'Отправка в течение 24 часов',
  },
  {
    key: '48小时以内出货',
    value: 'Отправка в течение 48 часов',
  },
  {
    key: '7天无理由退换商品',
    value: 'Возврат и обмен товара без объяснения причин в течение 7 дней',
  },
  {
    key: '1件起订',
    value: 'Минимальный заказ от 1 единицы',
  },
  {
    key: '月销量',
    value: 'Месячный объем продаж',
  },
  {
    key: '5星',
    value: '5 звезд',
  },
  {
    key: '4.5星~5星',
    value: '4.5 звезды ~ 5 звезд',
  },
  {
    key: '4星~4.5星',
    value: '4 звезды ~ 4.5 звезды',
  },
  {
    key: '查看更多',
    value: 'Показать еще',
  },
  {
    key: '没有更多了',
    value: 'Больше нет',
  },
  {
    key: '平台自营',
    value: 'Самостоятельная платформа',
  },
  {
    key: '根据您的喜好推荐',
    value: 'Рекомендации по вашим предпочтениям',
  },
  {
    key: '取消使用',
    value: 'Отменить использование',
  },
  {
    key: '因该订单实际采购数为0,无法进行下一步流程，请问是否取消该订单?',
    value:
      'Так как фактическое количество закупок по данному заказу равно 0, невозможно перейти к следующему шагу, отменить ли этот заказ?',
  },
  {
    key: '是',
    value: 'Да',
  },
  {
    key: '请输入收件人',
    value: 'Пожалуйста, введите получателя',
  },
  {
    key: '请输入手机号',
    value: 'Пожалуйста, введите номер телефона',
  },
  {
    key: '请输入详细地址',
    value: 'Пожалуйста, введите подробный адрес',
  },
  {
    key: '请输入账户名',
    value: 'Пожалуйста, введите имя учетной записи',
  },
  {
    key: '请输入您的银行账户',
    value: 'Пожалуйста, введите номер вашего банковского счета',
  },
  {
    key: '提现金额不能小于0',
    value: 'Сумма вывода не может быть меньше 0',
  },
  {
    key: '没有通知内容',
    value: 'Нет уведомлений',
  },
  {
    key: '请先选择要删除的通知',
    value: 'Нет доступных купонов',
  },
  {
    key: '暂无可用优惠券',
    value: 'Нет доступных купонов',
  },
  {
    key: '暂无商品',
    value: 'Нет товаров',
  },
  {
    key: '暂无店铺',
    value: 'Нет магазина',
  },
  {
    key: '未找到店铺内相关信息',
    value: 'Не найдена информация в магазине',
  },
  {
    key: '资金变动明细',
    value: 'Детали изменения средств',
  },
  {
    key: '中国总成本',
    value: 'Общая стоимость в Китае',
  },
  {
    key: '热销品类',
    value: 'Категории товаров для продажи',
  },
  {
    key: '无附加服务',
    value: 'Без дополнительных услуг',
  },
  {
    key: '展开',
    value: 'Развернуть',
  },
  {
    key: '收起',
    value: 'Свернуть',
  },
  {
    key: '暂无可用代金券',
    value: 'Нет доступных ваучеров',
  },
  {
    key: '物流方式说明',
    value: 'Логистические способы объяснения',
  },
  {
    key: '新增',
    value: 'Дополнительные',
  },
  {
    key: '商品已下架',
    value: 'Товар вышел из-под контроля',
  },
  {
    key: 'Ctrl+V 将图片粘贴到搜索栏中',
    value: 'Ctrl+V вставляет изображение в поле для поиска',
  },
  {
    key: '预计进口详细',
    value: 'Ожидаемый импорт подробности',
  },
  {
    key: '选择地址',
    value: 'Выберите адрес',
  },
  {
    key: '请完善商品信息',
    value: 'Пожалуйста, дополните информацию о товаре',
  },
  {
    key: '修改手机号',
    value: 'Изменить номер телефона',
  },
  {
    key: '预估总成本',
    value: 'Предварительная общая стоимость',
  },
  {
    key: '产品不可用',
    value: 'Продукт недоступен',
  },
  {
    key: '不可用',
    value: 'недоступен',
  },
  {
    key: '该邮箱未注册',
    value: 'Этот электронный адрес не зарегистрирован',
  },
  {
    key: '请输入您的邮箱地址',
    value: 'Введите ваш адрес электронной почты',
  },
  {
    key: '邮箱格式错误',
    value: 'Неправильный формат почтового ящика',
  },
  {
    key: '暂无通知消息',
    value: 'Нет уведомлений',
  },
  {
    key: '业务备注',
    value: 'Замечание от вашего агента.',
  },
  {
    key: '下单',
    value: 'Оформить заказ',
  },
  {
    key: '付款',
    value: 'Оплата товара',
  },
  {
    key: '入仓',
    value: 'Поступление на склад',
  },
  {
    key: '支付国际运费',
    value: 'Оплата международной доставки',
  },
  {
    key: '发货',
    value: 'Отправка груза',
  },
  {
    key: '清除',
    value: 'удалить',
  },
  {
    key: '等待报价',
    value: 'Ожидание предложения цены',
  },
  {
    key: '等待支付',
    value: 'Ожидает оплаты',
  },
  {
    key: '支付中',
    value: 'Оплата в процессе',
  },
  {
    key: '装箱单',
    value: 'Упаковочный лист',
  },
  {
    key: '客户备注',
    value: 'Примечания',
  },
  {
    key: '业务备注回复',
    value: 'Ответ',
  },
  {
    key: '订单详情',
    value: 'Детали заказа',
  },
  {
    key: '国际运输费用',
    value: 'Транспортные расходы',
  },
  {
    key: '国际物流成本',
    value: 'Стоимость интер. доставка',
  },
  {
    key: '当地物流成本',
    value: 'Местные логистические расходы',
  },
  {
    key: '装箱单状态',
    value: 'Статус упаковочного листа',
  },
  {
    key: '发货信息',
    value: 'Информация о доставке',
  },
  {
    key: '装箱单号',
    value: 'Номер упаковочного листа',
  },
  {
    key: '地区/州',
    value: 'Pегион',
  },
  {
    key: '装箱单备注',
    value: 'Комментарии к упаковочному листу',
  },
  {
    key: '包括以下订单中的产品',
    value: 'Заказ включает',
  },
  {
    key: '您可以点击运单号查看实时物流信息',
    value:
      'Нажмите на номер отправления, чтобы просмотреть информацию о доставке.',
  },
  {
    key: '运单号',
    value: 'Трек-номер',
  },
  {
    key: '物流方式',
    value: 'Способ доставки',
  },
  {
    key: '跟踪状态',
    value: 'Статус логистики:',
  },
  {
    key: '已发出',
    value: 'Отправлено',
  },
  {
    key: '本地配送中',
    value: 'В процессе местной доставки',
  },
  {
    key: '已送达',
    value: 'Доставлено',
  },
  {
    key: '正式提交',
    value: 'Формальное подтверждение',
  },
  {
    key: '业务已翻译待装箱',
    value: 'Бизнес переведен, ожидается упаковка',
  },
  {
    key: '已装箱完成待报价',
    value: 'Упаковка завершена, ожидается котировка',
  },
  {
    key: '已支付待确认',
    value: 'Оплачено, ожидается подтверждение',
  },
  {
    key: '已支付已确认',
    value: 'Оплачено и подтверждено',
  },
  {
    key: '已订舱待回复',
    value: 'Бронирование выполнено, ожидается ответ',
  },
  {
    key: '待装柜',
    value: 'Ожидается загрузка в контейнер',
  },
  {
    key: '待出货',
    value: 'Ожидается отправка',
  },
  {
    key: '异常',
    value: 'Аномалия',
  },
  {
    key: '装箱单详细信息',
    value: 'Подробная информация о упаковочном листе',
  },
  {
    key: '点击这里以展开或收起',
    value: 'Нажмите здесь, чтобы развернуть или свернуть',
  },
  {
    key: '装有相同货物的箱子数量',
    value: 'Число коробок с одинаковыми товарами',
  },
  {
    key: '产品英文名称',
    value: 'название товара',
  },
  {
    key: '包装数量',
    value: 'Количество',
  },
  {
    key: '下载包装清单',
    value: 'Скачать упаковочный лист',
  },
  {
    key: '请上传 image/jpeg, image/png, image/jpg 格式的图片',
    value:
      'Пожалуйста, загрузите изображения в формате image/jpeg, image/png, image/jpg',
  },
  {
    key: '文件读取失败',
    value: 'Ошибка чтения файла',
  },
  {
    key: '图片加载失败',
    value: 'Ошибка загрузки изображения',
  },
  {
    key: '图片压缩失败',
    value: 'Ошибка сжатия изображения',
  },
  {
    key: '点击切换图像,可以对图像进行多个上传',
    value:
      'Нажмите, чтобы переключить изображение, и вы сможете загрузить несколько изображений.',
  },
  {
    key: '清空并重新上传',
    value: 'Очистить и загрузить заново',
  },
  {
    key: '上传图片',
    value: 'Загрузить фото',
  },
  {
    key: '多选',
    value: 'Мультивыбор',
  },
  {
    key: '一次最多上传六张图片',
    value: 'Максимум шесть изображений за одну загрузку',
  },
  {
    key: '图片大小不得超过50MB',
    value: 'Размер изображения не должен превышать 50 МБ',
  },
  {
    key: '请上传jpeg,png,jpg格式的图片',
    value: 'Пожалуйста, загрузите изображения в формате JPEG, PNG или JPG',
  },
  {
    key: '处理失败',
    value: 'Ошибка обработки',
  },
  {
    key: '上传过程中发生错误',
    value: 'Произошла ошибка во время загрузки',
  },
  {
    key: '图片加载失败',
    value: 'Ошибка загрузки изображения',
  },
  {
    key: '登录失效,是否前往登录?',
    value: 'Вход недействителен, перейти к странице входа?',
  },
  {
    key: '请输入订单号/配送单号/商品ID搜索',
    value: 'Введите номер заказа, доставки или ID товара',
  },
  {
    key: '出货完了',
    value: 'Отгрузка завершена',
  },
  {
    key:
      'Sponlax让您轻松获得从中国进口的“一站式”服务，包括工厂采购、质量检验、附加服务和国际航运。',
    value:
      'Sponlax позволит Вам легко получить целый комплекс услуг по импорту из Китая, включая закупки с завода-изготовителя, проверку качества, дополнительные услуги и международную доставку.',
  },
  {
    key:
      '确认无误后，您可以点击”去付款“进行支付。确认收款后，我们将安排物流发货。物流更进详情将通过邮件发给您。如果您需要调整产品包装等，请将详细信息发送给我们。根据您的修改要求进行调整后，我们将提供新的报价。',
    value:
      'После подтверждения правильности ввода вы можете нажать ”Перейти к оплате“, чтобы произвести платеж. После подтверждения оплаты мы организуем логистику и отправку товара. Дальнейшая информация о логистике будет выслана Вам на электронную почту. Если Вам нужно внести коррективы в  упаковку продукта и т.д., пожалуйста, пришлите нам подробную информацию. После корректировки в соответствии с Вашими требованиями об изменениях мы предоставим Вам новое ценовое предложе',
  },
  {
    key: '淘宝',
    value: '淘宝',
  },
]
let chongFu = []
let fanyi = (value) => {
  for (let i = 0; i < langs.length; i++) {
    if (langs[i].key == value) {
      // 把所有首字母转为大写.trim().toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase())

      if (store.state.languagetype == 'English') {
        return langs[i].value
      } else if (store.state.languagetype == 'Chinese') {
        return langs[i].key
      }
    }
  }

  if (chongFu.indexOf(value) == -1) {
  }
  return value
}

export default fanyi
